<template>
  <div
    class="vehicle-schedule-main"
    :class="{ 'right-menu-layout-open': rightMenuShow }"
    :style="{ '--vehicle-right-menu-width': `${rightMenuWidth || 435}px` }"
  >

    <div class="gantt-container" ref="gantt-container">
      <div class="header-bar">
        <QuickFind
          :mainButtonText="quickFindMainButtonText"
          :showPopup.sync="showQuickFindPopup"
          popupTitle="Find Consignment Note"
          :buttonFilterIsOpen.sync="quickFindButtonFilterIsOpen"
          :searchByDropdownItems="quickFindSearchByDropdownItems"
          searchByDropdownItemKey="Search"
          :searchByDropdownSelectedObject.sync="quickFindSearchByDropdownSelectedObject"
          :searchCriteriaDropdownItems="quickFindSearchCriteriaDropdownItems"
          searchCriteriaDropdownItemKey="Criteria"
          :searchCriteriaDropdownSelectedObject.sync="quickFindSearchCriteriaDropdownSelectedObject"
          :searchCriteriaDropdownIsDisabled="quickFindSearchCriteriaDropdownIsDisabled"
          :searchValueControlType="quickFindSearchValueControlType"
          :searchValueControlIsDisabled="quickFindSearchValueIsDisabled"
          resultsTableBoxTitle="Consignment Notes"
          :resultsTableBoxData="quickFindResultsTableBoxData"
          :resultsTableBoxSelectedIndex="quickFindResultsTableBoxSelectedIndex"
          :resultsTableBoxHideColumns="quickFindResultsTableBoxHideColumns"
          @refresh="quickFindRefreshClicked"
          @select="quickFindSelectClicked"
        >
          <div slot="extraFiltersBottom" class="extra-filters-bottom">
            <Dropdown
              :items="quickFindViewOptionDropdownItems"
              itemKey="ViewOption"
              :selectedObject.sync="quickFindViewOptionDropdownSelectedObject"
              placeholder="View"
              :isRequired="true"
              :errorMessage.sync="quickFindViewOptionDropdownErrorMessage"
            />
            <Input
              :inputValue.sync="quickFindMaxRowsInputValue"
              placeholder="Max Rows"
              textType="number"
              :errorMessage.sync="quickFindMaxRowsErrorMessage"
            />
          </div>
          <div slot="filtersExtraSpace" class="filters-extra-space">
            {{quickFindFiltersExtraSpaceText}}
          </div>
        </QuickFind>
        <div style="padding: 5px; display: flex;">
          <Dropdown placeholder='PM Team' :items="PMTeamsItems" itemKey="Team" :selectedObject.sync="selectedPMTeams" style="width: 150px;"/>
          <button @click="filterPMTeam(selectedPMTeams)" style="width: 150px;">Filter PM Team </button>
        </div>
        <div class="date-container">
          <DateTimePicker placeholder="Show timeline from" :value.sync="startDate" />
          <DateTimePicker placeholder="to" :value.sync="endDate" />
          <div ref="refreshContainer" class="refresh-container">
            <button @click="showRefreshDropdown = !showRefreshDropdown">{{ refreshText }}</button>
            <div v-if="showRefreshDropdown" class="refresh-dropdown">
              <div>Refresh Every:</div>
              <button @click="refreshIntervalClicked($event, 10)">10 seconds</button>
              <button @click="refreshIntervalClicked($event, 30)">30 seconds</button>
              <button @click="refreshIntervalClicked($event, 300)">5 minutes</button>
              <button @click="refreshIntervalClicked($event, 600)">10 minutes</button>
              <button @click="refreshIntervalClicked($event, 1800)">30 minutes</button>
              <button @click="refreshIntervalClicked($event, 3600)">1 hour</button>
              <button class="refresh-now" @click="refreshIntervalClicked($event, null)">Refresh Now</button>
              <button v-if="refreshInterval" class="cancel-refresh" @click="refreshIntervalClicked(null, null)">Cancel Refresh</button>
            </div>
          </div>
          <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
        </div>
      </div>
      
      <div class="gantt-with-legends">
        <GanttChartV4 :items="filteredGanttItems" :interval="ganttInterval" :selectedRowKey="selectedGanttRowKey" :useSourceTaskBorder="false" :showZoomControls="true" @intervalChanged="ganttZoomChanged" @rowClicked="ganttRowClicked" :timeZoneWidth.sync="ganttMainWidth" ref="ganttChartComponent"/>
        <div class="gantt-legends">
          <div class="gantt-legends-items" v-for="(l, i) in legendsItems" :key="i">
            <div class="gantt-legends-color" :style="{ backgroundColor: l['ColorHexa'] }"></div>
            <div>{{ l['ColorDesc'] }}</div>
          </div>
        </div>
      </div>
    </div>

    <RightMenu
      :class="['right-menu', { 'right-menu-slide-open': rightMenuSlideOpen }]"
      :overlay="true"
      :maxWidth="550"
      :minWidth="435"
      :defaultWidth="435"
      :showCloseButton="false"
      :showMenu.sync="rightMenuShow"
      :width.sync="rightMenuWidth"
    >
      <div class="right-menu-content-container">
        <div v-if="!showAssignPanel" class="header-container"> <!-- don't show this header when AssignV3 is shown, AssignV3 has it's own header -->
          <div class="header-back-button" v-if="consignmentDetails" @click="hideConsignmentDetails">
            ᐊ <!-- showing consignment details -->
          </div>

          <div class="header-back-button" v-else-if="consignmentSelection['select'] != ''" @click="portDepotTripListBackClicked">
            ᐊ <!-- showing trips list where user selects a trip for port/depot booking -->
          </div>

          <div class="header-back-button" v-else-if="consignmentSelection['show']" @click="portDepotHomeBackClicked">
            ᐊ <!-- showing port/depot booking home -->
          </div>

          <!-- WEI JUN ADD HERE -->
          <div class="header-back-button" v-else-if="radioCallTabShow" @click="radioRadioBackClicked">
            ᐊ Radio Call -
          </div>
          <!--  -->

          <div class="header-title">
            {{ consignmentDetails ? `${(consignmentDetails['ConsignmentNo'] ? consignmentDetails['ConsignmentNo'].trim() : '')} - ${(consignmentDetails['PMNo'] ? consignmentDetails['PMNo'].trim() : '')} [${(consignmentDetails['Driver'] ? consignmentDetails['Driver'].trim() : '')}]` : (consignmentSelection['show'] || consignmentSelection['select'] != '') ? ((consignmentSelection['select'] != '') ? ('Select ' + consignmentSelection['select'] + ' job') : (`${mode} - ${hmsTitle}`)) : hmsTitle }}
          </div>
          <img @click="closeRightMenu" src="https://dsmlib.logistics.systems/Icons/error.png" style="width: 25px; height: 25px; background-color: white; border-radius: 50%; cursor: pointer;" alt="">
        </div>
        <div class="body-container">
          <div v-if="showAssignPanel" class="assign-panel-container">
            <AssignV3 :show.sync="showAssignPanel" :assignData="assignData" @tripAssigned="onTripAssigned"/>
          </div>
          <div v-else-if="consignmentDetails" class="consignment-details">
            <div class="consignment-row">
              <div class="consignment-label">Trip #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['JINo'] || consignmentDetails['JINo'].trim() == '' ? '-' : consignmentDetails['JINo']}}</div>
              <div class="consignment-details-right">{{ !consignmentDetails['MovementType'] || consignmentDetails['MovementType'].trim() == '' ? '-' : consignmentDetails['MovementType'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Cust</div>
              <div class="consignment-details-left">{{ !consignmentDetails['BillToName'] || consignmentDetails['BillToName'].trim() == '' ? '-' : consignmentDetails['BillToName']}}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">ROT No:</div>
              <div class="consignment-details-left">{{ !consignmentDetails['ROT'] || consignmentDetails['ROT'].trim() == '' ? '-' : consignmentDetails['ROT']}}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Cont #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['ContainerNo'] || consignmentDetails['ContainerNo'].trim() == '' ? '-' : consignmentDetails['ContainerNo'] }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['ContSize'] }}{{ consignmentDetails['ContType'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Seal #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['SealNo'] || consignmentDetails['SealNo'].trim() == '' ? '-' : consignmentDetails['SealNo'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">B2B</div>
              <div class="consignment-details-left">{{ !consignmentDetails['B2BContainerNo'] || consignmentDetails['B2BContainerNo'].trim() == '' ? '-' : consignmentDetails['B2BContainerNo'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">B2B Seal #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['B2BSealNo'] || consignmentDetails['B2BSealNo'].trim() == '' ? '-' : consignmentDetails['B2BSealNo'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">B2B CN</div>
              <div class="consignment-details-left">{{ !consignmentDetails['B2BConsignmentNo'] || consignmentDetails['B2BConsignmentNo'].trim() == '' ? '-': consignmentDetails['B2BConsignmentNo'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Bkg Ref</div>
              <div class="consignment-details-left">{{ consignmentDetails['BookingRefNo'] ? consignmentDetails['BookingRefNo'].trim() : '-' }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['ShipCall_No'] ? consignmentDetails['ShipCall_No'].trim() : '-' }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">From</div>
              <div class="consignment-details-left">{{ consignmentDetails['FromDestCode'] ? consignmentDetails['FromDestCode'].trim() : '-' }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['FromArea'] ? consignmentDetails['FromArea'].trim() : '-' }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Tel #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['FromTelNo1'] || consignmentDetails['FromTelNo1'].trim() == '' ? '-' : consignmentDetails['FromTelNo1'] }}</div>
              <div class="consignment-details-right">{{ !consignmentDetails['FromTelNo2'] || consignmentDetails['FromTelNo2'].trim() == '' ? '-' : consignmentDetails['FromTelNo2'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Address</div>
              <div class="consignment-details-left" v-html="formatConsignmentDetailsAddress('From')"></div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">To</div>
              <div class="consignment-details-left">{{ consignmentDetails['ToDestCode'] ? consignmentDetails['ToDestCode'].trim() : '-' }}</div>
              <div class="consignment-details-right">{{ consignmentDetails['ToArea'] ? consignmentDetails['ToArea'].trim() : '-' }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Tel #</div>
              <div class="consignment-details-left">{{ !consignmentDetails['ToTelNo1'] || consignmentDetails['ToTelNo1'].trim() == '' ? '-' : consignmentDetails['ToTelNo1']  }}</div>
              <div class="consignment-details-right">{{ !consignmentDetails['ToTelNo2'] || consignmentDetails['ToTelNo2'].trim() == '' ? '-' : consignmentDetails['ToTelNo2'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Address</div>
              <div class="consignment-details-left" v-html="formatConsignmentDetailsAddress('To')"></div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">B2B To</div>
              <div class="consignment-details-left">{{ !consignmentDetails['B2BToDestCode'] || consignmentDetails['B2BToDestCode'].trim() == '' ? '-' : consignmentDetails['B2BToDestCode'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Operator</div>
              <div class="consignment-details-left">{{ !consignmentDetails['Operator'] || consignmentDetails['Operator'].trim() == '' ? '-' : consignmentDetails['Operator']  }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Port/Depot Bkg</div>
              <div class="consignment-details-left">{{ `${!consignmentDetails['cmbookid'] || consignmentDetails['cmbookid'].trim() == '' ? '-' : consignmentDetails['cmbookid']} by ${!consignmentDetails['cmbookuser'] || consignmentDetails['cmbookuser'].trim() == '' ? '-' : consignmentDetails['cmbookuser']}` }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">Bkg Remarks</div>
              <div class="consignment-details-left">{{ !consignmentDetails['cmbookremarks'] || consignmentDetails['cmbookremarks'].trim() == '' ? '-' : consignmentDetails['cmbookremarks'] }}</div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">PU In/Out</div>
              <div class="consignment-details-left" style="white-space: nowrap;">
                {{
                  !consignmentDetails['PickupIn'] || consignmentDetails['PickupIn'].trim() == '' ? '[]' : `[${consignmentDetails['PickupIn']}]`
                }}
                /
                <wbr>
                {{
                  !consignmentDetails['PickupOut'] || consignmentDetails['PickupOut'].trim() == '' ? '[]' : `[${consignmentDetails['PickupOut']}]`
                }}
              </div>
            </div>
            <div class="consignment-row">
              <div class="consignment-label">DO In/Out</div>
              <div class="consignment-details-left" style="white-space: nowrap;">
                {{
                  !consignmentDetails['DropoffIn'] || consignmentDetails['DropoffIn'].trim() == '' ? '[]' : `[${consignmentDetails['DropoffIn']}]`
                }}
                /
                <wbr>
                {{
                  !consignmentDetails['DropoffOut'] || consignmentDetails['DropoffOut'].trim() == '' ? '[]' : `[${consignmentDetails['DropoffOut']}]`
                }}
              </div>
            </div>
          </div>
          <div v-else-if="consignmentSelection['select'] !== ''" class="port-depot-trips-list-container">
            <div v-if="pendingTripsIsLoading" class="port-depot-trips-loading-text">Loading Trips . . .</div>
            <div v-else-if="pendingTrips.length == 0" class="no-port-depot-trips">No Trips</div>
            <div class="port-depot-trips-list">
              <div
                v-for="(h, i) in pendingTrips /* use the same array as div.pending-trip-list, the data from the API is the same */"
                :key="i"
                class="hms-trips-content"
                :style="{
                  'display': hmsHideTrip(h) ? 'none' : '',
                }"
                @click="portDepotBookingTripSelected(h, i)"
              >
                <div class="trips-row">
                  <div class="trips-left">{{ h['ContainerNo'] }}</div>
                  <div class="trips-right">{{ h['ContSize'] }}{{ h['ContType'] ? h['ContType'].trim() : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ !h['B2BContainerNo'] ? '' : h['B2BContainerNo'] }}</div>
                  <div class="trips-right">{{ !h['B2BContSize'] ? '' : h['B2BContSize'].trim() }}{{ h['B2BContType'] ? h['ContType'].trim() : '' }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ h['ConsignmentNo'] ? h['ConsignmentNo'].trim() : '' }}</div>
                  <div class="trips-right">{{ h['MovementType'] }}</div>
                </div>
                <div class="trips-row">
                  <div class="trips-left">{{ h['BillToName'] ? h['BillToName'].trim() : '' }}</div>
                  <div class="trips-right">[{{ h['FromDestCode'] ? h['FromDestCode'].trim() : '' }} ({{ h['FromArea'] ? h['FromArea'].trim() : '' }}) - {{ h['ToDestCode'] ? h['ToDestCode'].trim() : '' }} ({{ h['ToArea'] ? h['ToArea'].trim() : '' }})]</div>
                </div>
                <Tooltip v-if="h['PickupIn'] || h['PickupOut'] || h['DropoffIn'] || h['DropoffOut']" style="position: absolute; top: 3px; right: 3px;" :showIndicator="false" :iconSize="18" position="left" :minWidth="200">
                  <img style="width: 20px; height: 20px;" src="https://dsmlib.logistics.systems/Icons/TruckOn.png"/>
                  <div slot="tooltipText">
                    <span>Next Action : {{(h['DropoffIn'] ? 'Drop Off Out' : (h['PickupOut'] ? 'Drop Off In' : (h['PickupIn'] ? 'Pick Up Out' : 'Pick Up In'))) }}</span>
                  </div>
                </Tooltip>
                <Tooltip style="position: absolute; top: 30%; right: 3px; cursor: pointer;" v-if="h['cmbook']" :showIndicator="false" :iconSize="18" position="left" :minWidth="250">
                  <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/icon8-booking.png"/>
                  <div slot="tooltipText">
                    <span>Port/Depot Bkg : {{ `${!h['cmbookid'] || h['cmbookid'].trim() == '' ? '-' : h['cmbookid']} by ${!h['cmbookuser'] || h['cmbookuser'].trim() == '' ? '-' : h['cmbookuser']}` }}</span>
                    <br>
                    <span>Bkg Remarks : {{ !h['cmbookremarks'] || h['cmbookremarks'].trim() == '' ? '-' : h['cmbookremarks'] }}</span>
                  </div>
                </Tooltip>
                <Tooltip @click.native="showConsignmentDetails(h, 'portDepotTripSelect')" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"/>
              </div>
            </div>
          </div>
          <div v-else-if="consignmentSelection['show']" class="port-depot-booking-home"> <!-- port/depot booking home, where the selected consignments for export/import/dropoff/pickup are shown -->
            <div class="consignment">
              <div class="title">
                <div class="label">{{consignmentSelection['upperLabel']}}</div>
                <div
                  class="cancel"
                  :style="{
                    'color': (consignmentSelection['upperSelected'] ? '' : '#fff3'),
                    'pointer-events': (consignmentSelection['upperSelected'] ? '' : 'none'),
                  }"
                  @click="resetUpperSelection"
                >
                  &#9587;
                </div>
              </div>
              <div class="content">
                <div class="hms-trips-content" v-if="consignmentSelection['upperSelected']" :style="{
                  'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : '')}" style="position: relative;"
                  @click="portDepotBookingShowTrips('upper')">
                  <div class="trips-row">
                    <div class="trips-left">{{ consignmentSelection['upperSelected']['ContainerNo'] ? consignmentSelection['upperSelected']['ContainerNo'].trim() : '' }}</div>
                    <div class="trips-right">{{ consignmentSelection['upperSelected']['ContSize'] ? consignmentSelection['upperSelected']['ContSize'].trim() : '' }}{{ consignmentSelection['upperSelected']['ContType'] ? consignmentSelection['upperSelected']['ContType'].trim() : '' }}</div>
                  </div>
                  <div class="trips-row">
                    <div class="trips-left">{{ !consignmentSelection['upperSelected']['B2BContainerNo'] ? '' : consignmentSelection['upperSelected']['B2BContainerNo'] }}</div>
                    <div class="trips-right">{{ !consignmentSelection['upperSelected']['B2BContSize'] ? '' : consignmentSelection['upperSelected']['B2BContSize'].trim() }}{{ consignmentSelection['upperSelected']['B2BContType'] ? consignmentSelection['upperSelected']['ContType'].trim() : '' }}</div>
                  </div>
                  <div class="trips-row">
                    <div class="trips-left">{{ consignmentSelection['upperSelected']['ConsignmentNo'] ? consignmentSelection['upperSelected']['ConsignmentNo'].trim() : '' }}</div>
                    <div class="trips-right">{{ consignmentSelection['upperSelected']['MovementType'] ? consignmentSelection['upperSelected']['MovementType'].trim() : '' }}</div>
                  </div>
                  <div class="trips-row">
                    <div class="trips-left">{{ consignmentSelection['upperSelected']['BillToName'] ? consignmentSelection['upperSelected']['BillToName'].trim() : '' }}</div>
                    <div class="trips-right">[{{ consignmentSelection['upperSelected']['FromDestCode'] ? consignmentSelection['upperSelected']['FromDestCode'].trim() : '' }} ({{ consignmentSelection['upperSelected']['FromArea'] ? consignmentSelection['upperSelected']['FromArea'].trim() : '' }}) - {{ consignmentSelection['upperSelected']['ToDestCode'] ? consignmentSelection['upperSelected']['ToDestCode'].trim() : '' }} ({{ consignmentSelection['upperSelected']['ToArea'] ? consignmentSelection['upperSelected']['ToArea'].trim() : '' }})]</div>
                  </div>
                  <Tooltip v-if="consignmentSelection['upperSelected']['PickupIn'] || consignmentSelection['upperSelected']['PickupOut'] || consignmentSelection['upperSelected']['DropoffIn'] || consignmentSelection['upperSelected']['DropoffOut'] " style="position: absolute; top: 3px; right: 3px;" :showIndicator="false" :iconSize="18" position="left" :minWidth="200">
                    <img style="width: 20px; height: 20px;" src="https://dsmlib.logistics.systems/Icons/TruckOn.png"/>
                    <div slot="tooltipText">
                      <span>Next Action : {{(consignmentSelection['upperSelected']['DropoffIn'] ? 'Drop Off Out' : (consignmentSelection['upperSelected']['PickupOut'] ? 'Drop Off In' : (consignmentSelection['upperSelected']['PickupIn'] ? 'Pick Up Out' : 'Pick Up In'))) }}</span>
                    </div>
                  </Tooltip>
                  <Tooltip style="position: absolute; top: 30%; right: 3px;" v-if="consignmentSelection['upperSelected']['cmbook']" :showIndicator="false" :iconSize="18" position="left" :minWidth="250">
                    <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/icon8-booking.png"/>
                    <div slot="tooltipText">
                      <span>Port/Depot Bkg : {{ `${!consignmentSelection['upperSelected']['cmbookid'] || consignmentSelection['upperSelected']['cmbookid'].trim() == '' ? '-' : consignmentSelection['upperSelected']['cmbookid']} by ${!consignmentSelection['upperSelected']['cmbookuser'] || consignmentSelection['upperSelected']['cmbookuser'].trim() == '' ? '-' : consignmentSelection['upperSelected']['cmbookuser']}` }}</span>
                      <br>
                      <span>Bkg Remarks : {{ !consignmentSelection['upperSelected']['cmbookremarks'] || consignmentSelection['upperSelected']['cmbookremarks'].trim() == '' ? '-' : consignmentSelection['upperSelected']['cmbookremarks'] }}</span>
                    </div>
                  </Tooltip>
                  <Tooltip @click.native="showConsignmentDetails(consignmentSelection['upperSelected'], 'portDepotShowTripList')" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"/>
                </div>
                <div class="noselect" @click="portDepotBookingShowTrips('upper')" v-else>Click to select</div>
                <div class="errMsg" v-if="consignmentSelection['upperMsg']['errMsg']" :style="{ 
                  'background-color': (consignmentSelection['upperMsg']['status'] > 0 ? '' : '#b3ffc7'),
                  'border': (consignmentSelection['upperMsg']['status'] > 0 ? '' : 'solid 1px #00aa00')}">
                  {{ consignmentSelection['upperMsg']['errMsg'] }}
                </div>
              </div>
            </div>
            <div class="consignment">
              <div class="title">
                <div class="label">{{consignmentSelection['lowerLabel']}}</div>
                <div
                  class="cancel"
                  :style="{
                    'color': (consignmentSelection['lowerSelected'] ? '' : '#fff3'),
                    'pointer-events': (consignmentSelection['lowerSelected'] ? '' : 'none'),
                  }"
                  @click="resetLowerSelection"
                >
                  &#9587;
                </div>
              </div>
              <div class="content">
                <div class="hms-trips-content" v-if="consignmentSelection['lowerSelected']" :style="{
                  'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : '')}"
                  @click="portDepotBookingShowTrips('lower')" style="position: relative;">
                  <div class="trips-row">
                    <div class="trips-left">{{ consignmentSelection['lowerSelected']['ContainerNo'] ? consignmentSelection['lowerSelected']['ContainerNo'].trim() : '' }}</div>
                    <div class="trips-right">{{ consignmentSelection['lowerSelected']['ContSize'] ? consignmentSelection['lowerSelected']['ContSize'].trim() : '' }}{{ consignmentSelection['lowerSelected']['ContType'] ? consignmentSelection['lowerSelected']['ContType'].trim() : '' }}</div>
                  </div>
                  <div class="trips-row">
                    <div class="trips-left">{{ !consignmentSelection['lowerSelected']['B2BContainerNo'] ? '' : consignmentSelection['lowerSelected']['B2BContainerNo'] }}</div>
                    <div class="trips-right">{{ !consignmentSelection['lowerSelected']['B2BContSize'] ? '' : consignmentSelection['lowerSelected']['B2BContSize'].trim() }}{{ consignmentSelection['lowerSelected']['B2BContType'] ? consignmentSelection['lowerSelected']['ContType'].trim() : '' }}</div>
                  </div>
                  <div class="trips-row">
                    <div class="trips-left">{{ consignmentSelection['lowerSelected']['ConsignmentNo'] ? consignmentSelection['lowerSelected']['ConsignmentNo'].trim() : '' }}</div>
                    <div class="trips-right">{{ consignmentSelection['lowerSelected']['MovementType'] ? consignmentSelection['lowerSelected']['MovementType'].trim() : '' }}</div>
                  </div>
                  <div class="trips-row">
                    <div class="trips-left">{{ consignmentSelection['lowerSelected']['BillToName'] ? consignmentSelection['lowerSelected']['BillToName'].trim() : '' }}</div>
                    <div class="trips-right">[{{ consignmentSelection['lowerSelected']['FromDestCode'] ? consignmentSelection['lowerSelected']['FromDestCode'].trim() : '' }} ({{ consignmentSelection['lowerSelected']['FromArea'] ? consignmentSelection['lowerSelected']['FromArea'].trim() : '' }}) - {{ consignmentSelection['lowerSelected']['ToDestCode'] ? consignmentSelection['lowerSelected']['ToDestCode'].trim() : '' }} ({{ consignmentSelection['lowerSelected']['ToArea'] ? consignmentSelection['lowerSelected']['ToArea'].trim() : '' }})]</div>
                  </div>
                  <Tooltip v-if="consignmentSelection['lowerSelected']['PickupIn'] || consignmentSelection['lowerSelected']['PickupOut'] || consignmentSelection['lowerSelected']['DropoffIn'] || consignmentSelection['lowerSelected']['DropoffOut']" style="position: absolute; top: 3px; right: 3px;" :showIndicator="false" :iconSize="18" position="left" :minWidth="200">
                    <img style="width: 20px; height: 20px;" src="https://dsmlib.logistics.systems/Icons/TruckOn.png"/>
                    <div slot="tooltipText">
                      <span>Next Action : {{(consignmentSelection['lowerSelected']['DropoffIn'] ? 'Drop Off Out' : (consignmentSelection['lowerSelected']['PickupOut'] ? 'Drop Off In' : (consignmentSelection['lowerSelected']['PickupIn'] ? 'Pick Up Out' : 'Pick Up In'))) }}</span>
                    </div>
                  </Tooltip>
                  <Tooltip style="position: absolute; top: 30%; right: 3px;" v-if="consignmentSelection['lowerSelected']['cmbook']" :showIndicator="false" :iconSize="18" position="left" :minWidth="250">
                    <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/icon8-booking.png"/>
                    <div slot="tooltipText">
                      <span>Port/Depot Bkg : {{ `${!consignmentSelection['lowerSelected']['cmbookid'] || consignmentSelection['lowerSelected']['cmbookid'].trim() == '' ? '-' : consignmentSelection['lowerSelected']['cmbookid']} by ${!consignmentSelection['lowerSelected']['cmbookuser'] || consignmentSelection['lowerSelected']['cmbookuser'].trim() == '' ? '-' : consignmentSelection['lowerSelected']['cmbookuser']}` }}</span>
                      <br>
                      <span>Bkg Remarks : {{ !consignmentSelection['lowerSelected']['cmbookremarks'] || consignmentSelection['lowerSelected']['cmbookremarks'].trim() == '' ? '-' : consignmentSelection['lowerSelected']['cmbookremarks'] }}</span>
                    </div>
                  </Tooltip>
                  <Tooltip @click.native="showConsignmentDetails(consignmentSelection['lowerSelected'], 'portDepotShowTripList')" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"/>
                </div>
                <div class="noselect" @click="portDepotBookingShowTrips('lower')" v-else>Click to select</div>
                <div class="errMsg" v-if="consignmentSelection['lowerMsg']['errMsg']" :style="{ 
                  'background-color': (consignmentSelection['lowerMsg']['status'] > 0 ? '' : '#b3ffc7'),
                  'border': (consignmentSelection['lowerMsg']['status'] > 0 ? '' : 'solid 1px #00aa00')}">
                  {{ consignmentSelection['lowerMsg']['errMsg'] }}
                </div>
              </div>
            </div>
            <div class="depot" v-if="mode == 'Depot Booking'">
              <Dropdown :items="depotDropdownItems" :itemKey="'fullname'" :selectedObject.sync="depotDropdownSelected" placeholder="Depot" :isRequired="true"/>
            </div>
            <div class="functions">
              <button @click="resetUpperLowerSelection" :disabled="consignmentSelection['loading'] || !(consignmentSelection['upperSelected'] || consignmentSelection['lowerSelected'])">Reset</button>
              <button @click="verifyTrip" :disabled="consignmentSelection['loading'] || !(consignmentSelection['upperSelected'] || consignmentSelection['lowerSelected']) || (mode == 'Depot Booking' ? !depotDropdownSelected : false)">Confirm</button>
            </div>
            <div class="note">
              Select both for {{consignmentSelection['upperLabel']}} &amp; {{consignmentSelection['lowerLabel']}} Job, else leave blank for single job. <br>
              e.g. Select ONLY {{consignmentSelection['upperLabel']}} for {{consignmentSelection['upperLabel'].toLowerCase()}} job.
            </div>
          </div>
          <div v-else-if="radioCallTabShow" class="hms-update-status-task-container"> <!-- show HmsUpdateStatusTask component -->
            <HMSUpdateStatusTask :data="selectedWhiteContainer" :rightMenuWidth="rightMenuWidth" :attachmentsChanged.sync="radioCallAttachmentsChanged" @statusUpdate="radioCallStatusUpdated" @statusReverse="radioCallStatusReversed"/>
          </div>
          <div v-else-if="showRightMenuHome" class="right-menu-home-container"> <!-- show pending trips and trips history -->
            <div class="pending-trips-container" :style="{'height': pendingTripsContainerHeight}">
              <div class="pending-trips-header" @click="togglePendingTrips">
                <img src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png" alt="expand arrow" :style="{'transform': `rotate(${showPendingTrips ? 0 : 180}deg)`}">
                <span>Pending Trips</span>
              </div>
              <div class="pending-trips-box" :style="{'height': showPendingTrips ? 'calc(100% - 24px)' : 0}">
                <div v-if="pendingTripsIsLoading" class="pending-trips-loading-text">Loading Pending Trips . . .</div>
                <div v-else-if="pendingTrips.length == 0" class="no-pending-trips"> No Pending Trips</div>
                <div v-else class="pending-trips-list">
                  <BoxContainer
                    v-for="(items, date) in groupedByDate"
                    :key="date"
                    :title="`Work ticket ${new Date(date).formatString('yyyy-MM-dd')} (${items.length} ${items.length === 1 ? 'trip' : 'trips'})`"
                    :isCollapsible="true"
                    :isCollapsed="date !== earliestDate"
                    style="margin:5px;margin-top:15px;"
                  >
                    <div
                      v-for="h in items"
                      :key="h.JourneyGUID"
                      class="hms-trips-content"
                      :style="{
                        'background-color': (rightMenuHomeSelectedIndex['tripType'] == 'Pending' && rightMenuHomeSelectedIndex['index'] == h.originalIndex) ? 'rgb(120, 120, 255)' : '',
                        'color': (rightMenuHomeSelectedIndex['tripType'] == 'Pending' && rightMenuHomeSelectedIndex['index'] == h.originalIndex) ? 'white' : '',
                      }"
                      @click="pendingTripClicked(h, h.originalIndex)"
                    >
                      <div class="trips-row">
                        <div class="trips-left">{{ h['ContainerNo'] }}</div>
                        <div class="trips-right">{{ h['ContSize'] }}{{ h['ContType'] ? h['ContType'].trim() : '' }}</div>
                      </div>
                      <div class="trips-row">
                        <div class="trips-left">{{ !h['B2BContainerNo'] ? '' : h['B2BContainerNo'] }}</div>
                        <div class="trips-right">{{ !h['B2BContSize'] ? '' : h['B2BContSize'].trim() }}{{ h['B2BContType'] ? h['ContType'].trim() : '' }}</div>
                      </div>
                      <div class="trips-row">
                        <div class="trips-left">{{ h['ConsignmentNo'] ? h['ConsignmentNo'].trim() : '' }}</div>
                        <div class="trips-right">{{ h['MovementType'] }}</div>
                      </div>
                      <div class="trips-row">
                        <div class="trips-left">{{ h['BillToName'] ? h['BillToName'].trim() : '' }}</div>
                        <div class="trips-right">[{{ h['FromDestCode'] ? h['FromDestCode'].trim() : '' }} ({{ h['FromArea'] ? h['FromArea'].trim() : '' }}) - {{ h['ToDestCode'] ? h['ToDestCode'].trim() : '' }} ({{ h['ToArea'] ? h['ToArea'].trim() : '' }})]</div>
                      </div>
                      <Tooltip 
                        v-if="h['PickupIn'] || h['PickupOut'] || h['DropoffIn'] || h['DropoffOut']" 
                        style="position: absolute; top: 3px; right: 3px;" 
                        :showIndicator="false" 
                        :iconSize="18" 
                        position="left" 
                        :minWidth="200"
                      >
                        <img style="width: 20px; height: 20px;" src="https://dsmlib.logistics.systems/Icons/TruckOn.png"/>
                        <div slot="tooltipText">
                          <span>Next Action : {{(h['DropoffIn'] ? 'Drop Off Out' : (h['PickupOut'] ? 'Drop Off In' : (h['PickupIn'] ? 'Pick Up Out' : 'Pick Up In'))) }}</span>
                        </div>
                      </Tooltip>
                      <Tooltip 
                        style="position: absolute; top: 30%; right: 3px; cursor: pointer;" 
                        v-if="h['cmbook']" 
                        :showIndicator="false" 
                        :iconSize="18" 
                        position="left" 
                        :minWidth="250"
                      >
                        <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/icon8-booking.png"/>
                        <div slot="tooltipText">
                          <span>Port/Depot Bkg : {{ `${!h['cmbookid'] || h['cmbookid'].trim() == '' ? '-' : h['cmbookid']} by ${!h['cmbookuser'] || h['cmbookuser'].trim() == '' ? '-' : h['cmbookuser']}` }}</span>
                          <br>
                          <span>Bkg Remarks : {{ !h['cmbookremarks'] || h['cmbookremarks'].trim() == '' ? '-' : h['cmbookremarks'] }}</span>
                        </div>
                      </Tooltip>
                      <Tooltip 
                        @click.native="showConsignmentDetails(h, 'pendingHistoricalTripSelect')" 
                        class="trips-tooltip" 
                        :showIndicator="false" 
                        position="left" 
                        tooltipText="Consignment Details"
                      />
                    </div>
                  </BoxContainer>
                </div>
              </div>
            </div>
            <div class="trips-history-container" :style="{'height': tripsHistoryContainerHeight }">
              <div class="trips-history-header" @click="toggleTripsHistory">
                <img src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png" alt="expand arrow" :style="{'transform': `rotate(${showTripsHistory ? 0 : 180}deg)`}">
                <span>Trips History</span>
              </div>
              <div class="trips-history-box" :style="{'height': showTripsHistory ? 'calc(100% - 24px)' : 0}">
                <div v-if="tripsHistoryIsLoading" class="trips-history-loading-text">Loading Completed Trips . . .</div>
                <div v-else-if="tripsHistory.length == 0" class="no-trips-history"> No Completed Trips</div>
                <div v-else class="trips-history-list">
                  <div
                    v-for="(h, i) in tripsHistory"
                    :key="i"
                    class="hms-trips-content"
                    :style="{
                      'cursor': ((consignmentSelection['show'] || consignmentSelection['select'] != '') ? 'pointer' : ''),
                      'backgroundColor': (rightMenuHomeSelectedIndex['tripType'] == 'Historical' && rightMenuHomeSelectedIndex['index'] == i) ? 'rgb(120, 120, 255)' : '',
                      'color': (rightMenuHomeSelectedIndex['tripType'] == 'Historical' && rightMenuHomeSelectedIndex['index'] == i) ? 'white' : ''
                    }"
                    @click="historicalTripClicked(h, i)"
                  >

                    <div class="trips-row">
                      <div class="trips-left">{{ h['ContainerNo'] }}</div>
                      <div class="trips-right">{{ h['ContSize'] }}{{ h['ContType'] ? h['ContType'].trim() : '' }}</div>
                    </div>
                      <!--  -->
                    <div class="trips-row">
                      <div class="trips-left">{{ !h['B2BContainerNo'] ? '' : h['B2BContainerNo'] }}</div>
                      <div class="trips-right">{{ !h['B2BContSize'] ? '' : h['B2BContSize'].trim() }}{{ h['B2BContType'] ? h['ContType'].trim() : '' }}</div>
                    </div>
                      <!--  -->
                    <div class="trips-row">
                      <div class="trips-left">{{ h['ConsignmentNo'] ? h['ConsignmentNo'].trim() : '' }}</div>
                      <div class="trips-right">{{ h['MovementType'] }}</div>
                    </div>
                    <div class="trips-row">
                      <div class="trips-left">{{ h['BillToName'] ? h['BillToName'].trim() : '' }}</div>
                      <div class="trips-right">[{{ h['FromDestCode'] ? h['FromDestCode'].trim() : '' }} ({{ h['FromArea'] ? h['FromArea'].trim() : '' }}) - {{ h['ToDestCode'] ? h['ToDestCode'].trim() : '' }} ({{ h['ToArea'] ? h['ToArea'].trim() : '' }})]</div>
                    </div>
                    <Tooltip @click.native="showConsignmentDetails(h, 'pendingHistoricalTripSelect')" class="trips-tooltip" :showIndicator="false" position="left" tooltipText="Consignment Details"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- only show one of these footers if AssignV3 isn't shown, because AssignV3 has it's own footer -->
        <div v-if="!showAssignPanel && !radioCallTabShow" class="footer-container"> <!-- call to action buttons -->
          <button
            :disabled="
              pendingTripsIsLoading ||
              tripsHistoryIsLoading ||
              consignmentSelection['show'] ||
              consignmentSelection['select'] != ''
            "
            @click="portBookingButtonClicked"
          >
            Port Booking
          </button>
          <button
            :disabled="
              true || // disable depot booking because there's an issue with CargoMove's API
              pendingTripsIsLoading ||
              tripsHistoryIsLoading ||
              consignmentSelection['show'] ||
              consignmentSelection['select'] != ''
            "
            @click="depotBookingButtonClicked"
          >
            Depot Booking
          </button>
          <button
            :disabled="
              pendingTripsIsLoading ||
              tripsHistoryIsLoading ||
              !selectedWhiteContainer ||
              consignmentSelection['show'] ||
              consignmentSelection['select'] != ''
            "
            @click="radioCallButtonClicked"
          >
            {{ radioCallButtonTitle }}
          </button>

          <div class="more-actions">
            <button
              :disabled="!selectedVehicleCode || pendingTripsIsLoading || tripsHistoryIsLoading || consignmentSelection.show || consignmentSelection.select != ''"
              @click="showMoreActionsMenu = !showMoreActionsMenu"
            >
              <div> <!-- 20px x 20px -->
                <img src="https://dsmlib.logistics.systems/Icons/icons8-ellipsis-100.png" alt="More Actions"> <!-- 15px x 15px, because icon is too thick -->
              </div>
            </button>

            <div v-if="showMoreActionsMenu" class="actions-menu">
              <button
                :disabled="
                  pendingTripsIsLoading ||
                  tripsHistoryIsLoading ||
                  !selectedWhiteContainer ||
                  consignmentSelection['show'] ||
                  consignmentSelection['select'] != ''
                "
                @click="moreActionsEditTripButtonClicked"
              >
                Edit Trip
              </button>
              <button
                :disabled="
                  pendingTripsIsLoading ||
                  tripsHistoryIsLoading ||
                  !selectedWhiteContainer ||
                  consignmentSelection['show'] ||
                  consignmentSelection['select'] != ''
                "
                @click="moreActionsDeleteTripButtonClicked"
              >
                Delete Trip
              </button>
              <button
                :disabled="
                  pendingTripsIsLoading ||
                  tripsHistoryIsLoading ||
                  !selectedWhiteContainer ||
                  !selectedWhiteContainer['cmbook'] ||
                  consignmentSelection['show'] ||
                  consignmentSelection['select'] != ''
                "
                @click="cancelPortBooking"
              >
                Cancel Booking
              </button>
              <button @click="showMoreActionsMenu = false">Close</button>
            </div>
          </div>
          <button
            v-if="showRightMenuHome && selectedVehicleCode"
            type="button"
            class="vehicle-tasks-button"
            :disabled="pendingTripsIsLoading || tripsHistoryIsLoading || consignmentSelection.show || consignmentSelection.select != ''"
            :title="vehicleTaskCount > 0 ? `Vehicle Tasks: ${vehicleTaskCount} Pending` : 'Vehicle Tasks'"
            :aria-label="vehicleTaskCount > 0 ? `Vehicle Tasks: ${vehicleTaskCount} Pending` : 'Vehicle Tasks'"
            @click="openVehicleTasks"
          >
            <img src="https://dsmlib.logistics.systems/Icons/edit-info.png" alt="" aria-hidden="true">
            <span v-if="vehicleTaskCount > 0" class="vehicle-tasks-badge" aria-hidden="true">{{ vehicleTaskCount > 99 ? '99+' : vehicleTaskCount }}</span>
          </button>
        </div>
        <div v-else-if="!showAssignPanel && radioCallTabShow" class="footer-container" style="min-height: 80px; max-height: 80px; background-color: #535cda !important;">
          <div class="message-container" :style="messageContainerStyling" style="font-weight: bold;" v-html="radioCallResultMessage"></div>
        </div>
        <div class="loader" v-if="consignmentSelection['loading']">
          <div class="load-text">{{ consignmentSelection['loadingMsg'] }}</div>
        </div>
      </div>
    </RightMenu>

    <EntryPopup :show.sync="showBookingPopup" :title="consignmentBook['title']" :content.sync="consignmentBook['content']"
      :successMessages.sync="consignmentBook['successMessages']" :errorMessages.sync="consignmentBook['errorMessages']"
      :disabledSave="(consignmentBook['saved'] || consignmentBook['content']['popupData']['timeout'] <= 0)"
      :newStyle="true" :isComponent="true"
      @saved="entryPopupSaveClicked()" />

    <PopupEntry
      v-if="showPopupEntry"
      :show.sync="showPopupEntry"
      :title="popupEntryTitle"
      :createdBy="popupEntryCreatedBy"
      :updatedBy="popupEntryUpdatedBy"
      :messages="popupEntryMessages"
      :successMessages="popupEntrySuccessMessages"
      :errorMessages="popupEntryErrorMessages"
      :requiredError="popupEntryRequiredError"
      :viewMode="popupEntryViewMode"
      @save="popupEntrySaveClicked"
      @requiredClicked="popupEntryRequiredClicked($event)"
    >
      <div v-if="mode == 'Depot Booking'" class="portbook-main">

        <div class="portbook-timeout">
          Timeout: {{ formatDepotBookingTimeoutTime }}
        </div>

        <div class="portbook-timeout-cover" v-if="depotBookingTimeoutTime <= 0">
          <div class="title">Session Timed Out</div>
        </div>

        <div class="portbook-jobs">
          <div class="job-item" v-for="(j, i) in depotBookingJobs" :key="'job' + i">
            <div class="job-header">{{ j ? (j['ConsignmentNo'] ? j['ConsignmentNo'].trim() : '') : '' }}</div>

            <div class="job-row">
              <div class="title">
                <!-- <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('1') : -1) >= 0) ? 'green' : 'red') }">Driver</div> -->
                <!-- <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('1') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/> -->
                <div class="title-text" style="color: green;">Driver</div>
                <img class="title-icon" src='https://dsmlib.logistics.systems/Icons/icons8-thumbs-up-96.png' alt=""/>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['DriverName'] ? j['DriverName'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['drivernric'] ? j['drivernric'].trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="job-row">
              <div class="title">
                <!-- <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('2') : -1) >= 0) ? 'green' : 'red') }">Vehicle Head</div> -->
                <!-- <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('2') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/> -->
                <div class="title-text" style="color: green;">Vehicle Head</div>
                <img class="title-icon" src='https://dsmlib.logistics.systems/Icons/icons8-thumbs-up-96.png' alt=""/>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['PMCode'] ? j['PMCode'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['PMNo'] ? j['PMNo'].trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="job-row">
              <div class="title">
                <div class="title-text">Trailer</div>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['TRCode'] ? j['TRCode'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['TRNo'] ? j['TRNo'].trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="job-row">
              <div class="title">
                <div class="title-text">Container(s)</div>
              </div>
              <div class="value">
                <div class="value-row">{{ j ? (j['ContainerNo'] ? j['ContainerNo'].trim() : '-') : '-' }}</div>
                <div class="value-row">{{ j ? (j['B2BContainerNo'] ? j['B2BContainerNo'].trim() : '-') : '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="portbook-functions">
          <div class="timeslot-details">
            <div class="timeslot-row">
              <div class="title">
                <div class="title-text">Total</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['total'] ? depotBookingSelectedTimeslot['total'].toString().trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="timeslot-row">
              <div class="title">
                <div class="title-text">Available</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['available'] ? depotBookingSelectedTimeslot['available'].toString().trim() : '-') : '-' }}</div>
              </div>
            </div>
            <div class="timeslot-row">
              <div class="title">
                <div class="title-text">Used</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['used'] ? depotBookingSelectedTimeslot['used'].toString().trim() : '-') : '-' }}</div>
              </div>
            </div>

            <div class="timeslot-row" style="width: 100%;">
              <div class="title">
                <div class="title-text">Timeslot Date/Time</div>
              </div>
              <div class="value">
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['start'] ? ('Start : ' + depotBookingSelectedTimeslot['start'].toString().trim()) : '-') : '-' }}</div>
                <div class="value-row">{{ depotBookingSelectedTimeslot ? (depotBookingSelectedTimeslot['end'] ? ('End   : ' + depotBookingSelectedTimeslot['end'].toString().trim()) : '-') : '-' }}</div>
              </div>
            </div>
          </div>

          <Input placeholder="Depot" :isDisabled="true" :inputValue="depotBookingDepotInput"/>
          <Dropdown ref="depotBookingTimeslotDropdown" placeholder="Timeslot" :isDisabled="popupEntryViewMode" :items="depotBookingTimeslots" itemKey="start" :selectedObject.sync="depotBookingSelectedTimeslot" :isRequired="true"/>
          <Dropdown ref="depotBookingOperatorDropdown" placeholder="Operator" :isDisabled="popupEntryViewMode" :items="depotDropdownSelected['operators']" itemKey="operator" :selectedObject.sync="depotBookingSelectedOperator" :isRequired="true"/>
          <Dropdown ref="depotBookingTrailerDropdown" placeholder="Trailer" :isDisabled="popupEntryViewMode" :items="depotBookingTrailers" itemKey="description" :selectedObject.sync="depotBookingSelectedTrailer" :isRequired="true"/>
          <RemarksBox class="portbook-remarks" title="Remarks" :isDisabled="popupEntryViewMode" :maxLength="300" :text.sync="depotBookingRemarks" />
        </div>
      </div>
    </PopupEntry>

    <PopupV2 :show="showCancelBookingPopup" title="Cancel Booking" @buttonClicked="cancelPortBookingClicked" :buttons="cancelBookingPopupButton" height="45%" width="30%">
      <div style="white-space: pre-wrap;">Are you sure you want to cancel this booking({{cancelBookingID}})?<br>You can't undo this action.</div>
      <Input placeholder="Reason" :isRequired="true" :inputValue.sync="cancelBookingNotes" />
    </PopupV2>

    <PopupV2
      class="delete-trip-popup"
      :show="showDeleteTripPopup"
      type="warning"
      title="Delete Trip"
      :buttons="deleteTripPopupButtons"
      @buttonClicked="deleteTripPopupButtonClicked"
    >
      <div class="prompt">
        <span>Are you sure you want to delete this trip?</span>
      </div>
      <table class="trip-details">
        <tr>
          <td class="detail-name">Driver</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? `${selectedWhiteContainer['DriverName']} (${selectedWhiteContainer['Driver']})` : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Prime Mover</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? `${selectedWhiteContainer['PMNo']} (${selectedWhiteContainer['PMCode']})` : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Consignment No.</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? selectedWhiteContainer['ConsignmentNo'] : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Container No.</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? selectedWhiteContainer['ContainerNo'] : ''}}</td>
        </tr>
        <tr>
          <td class="detail-name">Movement Type</td>
          <td class="detail-colon">:</td>
          <td class="detail-value">{{selectedWhiteContainer ? selectedWhiteContainer['MovementType'] : ''}}</td>
        </tr>
      </table>
      <Input
        class="reason"
        placeholder="Reason"
        :inputValue.sync="deleteTripPopupReasonInputValue"
        :isRequired="true"
        :errorMessage.sync="deleteTripPopupReasonInputErrorMessage"
      />
    </PopupV2>

    <FinishedTripVehicleTasks ref="vehicleTasksPopup" @closed="refreshVehicleTaskCount()" />
  </div>
</template>

<script>
/* eslint-disable */
import QuickFind from '@/components/QuickFind.vue';
import FinishedTripVehicleTasks from '@/components/VehicleTodo/FinishedTripVehicleTasks.vue';

export default {
  components: {
    QuickFind,
    FinishedTripVehicleTasks,
  },
  data: function() {
    return {
      // Quick Find data fields
      quickFindMainButtonText: '<img src="https://dsmlib.logistics.systems/Icons/Search.png" style="height: 20px; width: 20px;"> Find Consignment Note',
      showQuickFindPopup: false,
      quickFindButtonFilterIsOpen: false,
      quickFindSearchByDropdownItems: [],
      quickFindSearchByDropdownSelectedObject: {},
      quickFindSearchCriteriaDropdownItems: [],
      quickFindSearchCriteriaDropdownSelectedObject: {},
      quickFindSearchCriteriaDropdownIsDisabled: false,
      quickFindSearchValueControlType: "Input",
      quickFindSearchValueIsDisabled: false,
      quickFindViewOptionDropdownItems: [],
      quickFindViewOptionDropdownSelectedObject: {},
      quickFindViewOptionDropdownErrorMessage: "",
      quickFindMaxRowsInputValue: '',
      quickFindMaxRowsErrorMessage: "",
      quickFindFiltersExtraSpaceText: "",
      quickFindResultsTableBoxData: [],
      quickFindResultsTableBoxSelectedIndex: [],
      selectedPMTeams: null,

      showAssignPanel: false,
      assignData: null,

      rightMenuShow : false,
      rightMenuWidth : 0,
      rightMenuSlideOpen: false,
      ganttViewportSyncTimer: 0,
      rightMenuHomeSelectedIndex: {
        "tripType": "", // "Pending" | "Historical"
        "index": -1, // index of selected trip
      },
      selectedWhiteContainer : null,
      radioCallTabShow : false,
      radioCallResult : '',
      mainPageShow : false,
      selectedVehicleCode : '',
      selectedDriver: '',
      vehicleTaskCount: 0,
      vehicleTaskCountRevision: 0,
      vehicleTaskJourneyGuids: [],

      radioCallAttachmentsChanged: false,
      radioCallUpdateSuccess : null,
      radioCallResultMessage : '',

      ganttMainWidth: 0,
      loading: false,
      loadText: 'Loading',

      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59),

      ganttInterval: 30,
      ganttItems: [],
      filteredGanttItems: [],
      selectedGanttRowKey: '',
      legendsItems: [],
      PMTeamsItems: [],

      showRightMenuHome: false, // screen showing all trips, right before clicking Port Booking / Depot Booking
      showPendingTrips: true, // expand/collapse the pending trips box
      showTripsHistory: false, // expand/collapse the trips history box
      hmsTitle: '',
      pendingTripsIsLoading: false,
      pendingTrips: [],
      tripsHistoryIsLoading: false,
      tripsHistory: [],
      consignmentDetails: null,

      showRefreshDropdown: false,
      refreshTime: 0,
      refreshTimeStart: 0,
      refreshInterval: null,

      lastRefresh: '',

      showMoreActionsMenu: false,

      mode: '', // 'Port Booking' or 'Depot Booking'
      consignmentSelection: {
        'show': false,
        'upperLabel': '', // Export for port booking / Dropoff for depot booking
        'upperSelected': null,
        'lowerLabel': '', // Import for port booking / Pickup for depot booking
        'lowerSelected': null,
        'loading': false,
        'loadingMsg': 'Verifying',

        'select': '', // export/import/dropoff/pickup, depends on what the user last selected
        'portbookType': '', // upperlower/upper/lower
        // the reason there's a difference between select and portbookType
        // select is mainly used for display in the template
        // portbookType is used in the JavaScript portion
        // portbookType is usually used with string interpolation to easily refer to upperSelected, lowerSelected, lowerMsg and so on

        'upperMsg': { 'status': 0, 'errMsg': '' },
        'lowerMsg': { 'status': 0, 'errMsg': '' },
      },

      // data fields for Dropdown in div.port-depot-booking-home.depot
      depotDropdownItems: [],
      depotDropdownSelected: null,

      showBookingPopup: false, // show EntryPopup
      consignmentBook: { // used for port booking, passed to EntryPopup
        'title': '',
        'content': {
          type: 'PortBookingv2', // use the PortBookingV2 component imported in EntryPopup
          popupData: {
            'timeout': 300,
            'loadText': '',
            'jobs': [],
            'trailers': []
          }
        },
        'timeoutInterval': null, // used to store the interval ID returned by setInterval

        'saved': false,

        'successMessages': [],
        'errorMessages': [],
      },

      // PopupEntry data fields
      showPopupEntry: false,
      popupEntryTitle: '',
      popupEntryCreatedBy: '', // blank by default, so that the box on the top right won't show
      popupEntryUpdatedBy: '', // blank by default, so that the box on the top right won't show
      popupEntryMessages: [],
      popupEntrySuccessMessages: [],
      popupEntryErrorMessages: [],
      popupEntryRequiredError: [],
      popupEntryViewMode: false,

      // depot booking popupentry data fields
      depotBookingTimeoutTime: 300, // time before timeout in seconds
      depotBookingTimeoutInterval: null, // stores interval ID returned by setInterval, needed for clearInterval later on
      depotBookingJobs: [], // stores consignment details to be displayed inside PopupEntry, can either contain a Dropoff job only, a Pickup job only, or a Dropoff and Pickup job
      depotBookingDepotInput: '', // bound to the Input component in PopupEntry, the Input component is disabled and is only used to display this value
      depotBookingTimeslots: [], // bound to the timeslots Dropdown in PopupEntry
      depotBookingSelectedTimeslot: null, // bound to the timeslots Dropdown in PopupEntry
      depotBookingSelectedOperator: null, // bound to the operators Dropdown in PopupEntry
      depotBookingTrailers: [],
      depotBookingSelectedTrailer: null,
      depotBookingRemarks: '', // bound to RemarksBox in PopupEntry

      //cancel booking data
      showCancelBookingPopup: false,
      cancelBookingPopupButton: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' }
      ],
      cancelBookingID: '',
      cancelBookingJourneyGUID: '',
      cancelBookingB2BJourneyGUID: '',
      cancelBookingNotes: '',

      // delete trip popupV2 data fields
      showDeleteTripPopup: false,
      deleteTripPopupButtons: [
        { "text": "Delete", "color": "red", "textColor": "white" },
        { "text": "Cancel", "color": "lightgray" },
      ],
      deleteTripPopupReasonInputValue: "",
      deleteTripPopupReasonInputErrorMessage: "",
    }
  },
  props: {
  },
  computed: {
    vehicleTaskRequest: function() {
      const trip = this.selectedWhiteContainer;
      return trip && trip.JourneyGUID
        ? { vehiclecode: String(trip.PMCode || this.selectedVehicleCode).trim(), selectedjourneyguid: String(trip.JourneyGUID).trim() }
        : { vehiclecode: this.selectedVehicleCode, journeyguids: this.vehicleTaskJourneyGuids.slice() };
    },
    quickFindResultsTableBoxHideColumns: function() {
      if (!this.quickFindResultsTableBoxData || this.quickFindResultsTableBoxData.length === 0) {
        return [];
      }

      const keys = Object.keys(this.quickFindResultsTableBoxData[0]);
      return keys.filter((key) => { return key.startsWith("tag_"); }); // hide all columns with names starting with "tag_"
    },
    radioCallButtonTitle: function() {
      if (
        (this.rightMenuHomeSelectedIndex["tripType"] == "" && this.rightMenuHomeSelectedIndex["index"] == -1) || // no trip selected
        this.consignmentSelection["show"] ||
        this.consignmentSelection["select"]
      ) {
        return "...";
      }

      if (this.selectedWhiteContainer["DropoffOut"]) {
        return "View Updates";
      }

      if (this.selectedWhiteContainer["DropoffIn"]) {
        return "Drop Off Out";
      }

      if (this.selectedWhiteContainer["PickupOut"]) {
        return "Drop Off In";
      }

      if (this.selectedWhiteContainer["PickupIn"]) {
        return "Pick Up Out";
      }

      return "Pick Up In";
    },
    refreshText: function() {
      if (!this.refreshInterval) { return 'Refresh Timeline' }
      else {
        let totalSeconds = this.refreshTime;
        let inMinute = Math.floor(totalSeconds / 60);

        if (totalSeconds >= 60) {
          return `Refresh in ${inMinute} minute${inMinute > 1 ? 's' : ''}`;
        } else {
          return `Refresh in ${this.refreshTime} seconds`;
        }
      }
    },
    pendingTripsContainerHeight: function() {
      if (!this.showPendingTrips) {
        return "26px";
      }
      return this.showTripsHistory ? "50%" : "calc(100% - 26px)";
    },
    tripsHistoryContainerHeight: function() {
      if (!this.showTripsHistory) {
        return "26px";
      }
      return this.showPendingTrips ? "50%" : "calc(100% - 26px)";
    },
    formatDepotBookingTimeoutTime: function() { // formats timeout seconds to XX:xx
      let minutes = Math.floor(this.depotBookingTimeoutTime / 60);
      let seconds = this.depotBookingTimeoutTime % 60;

      return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    messageContainerStyling : function() {
      return {
        backgroundColor : (this.radioCallUpdateSuccess === null) ? 'lightyellow' : (this.radioCallUpdateSuccess === true) ? 'lightgreen' : 'indianred',
        color : (this.radioCallUpdateSuccess === false ) ? 'white' : 'black'
      }
    },
    groupedByDate: function() {
      // Add original index to each item 
      const itemsWithIndex = this.pendingTrips.map((item, index) => ({
        ...item,
        originalIndex: index
      }));
      
      // Group by JIDate
      const grouped = itemsWithIndex.reduce((acc, item) => {
        const date = item.JIDate;
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});
      
      // Sort by date ascending
      return Object.keys(grouped)
        .sort((a, b) => b.localeCompare(a))
        .reduce((acc, key) => {
          acc[key] = grouped[key];
          return acc;
        }, {});
    },
    earliestDate: function() {
      const dates = Object.keys(this.groupedByDate);
      if (dates.length === 0) return null;
      
      return dates[dates.length - 1];
    }
  },
  methods: {
    syncVehicleGanttViewport: function() {
      const gantt = this.$refs['ganttChartComponent'];
      if (gantt && gantt.suspendViewportResize) {
        gantt.suspendViewportResize(350);
      }
      if (this.ganttViewportSyncTimer) {
        clearTimeout(this.ganttViewportSyncTimer);
      }
      this.ganttViewportSyncTimer = setTimeout(() => {
        this.ganttViewportSyncTimer = 0;
        const currentGantt = this.$refs['ganttChartComponent'];
        const ganttContainer = this.$refs['gantt-container'];
        if (currentGantt && currentGantt.syncViewportLayout) {
          currentGantt.syncViewportLayout();
        }
        if (ganttContainer) {
          this.ganttMainWidth = Math.max(0, ganttContainer.getBoundingClientRect().width - 115);
        }
      }, 350);
    },
    getQuickFindField: async function(field) {
      return this.$apiCallV2(`/VehicleSchedule/QuickFindFilter?field=${field}`);
    },
    quickFindRefreshClicked: async function(error, inputs) {
      let extraControlsError = false;

      if (
        !this.quickFindViewOptionDropdownSelectedObject || // selected object is null
        Object.keys(this.quickFindViewOptionDropdownSelectedObject).length == 0 // selected object is empty
      ) {
        this.quickFindViewOptionDropdownErrorMessage = "View Option is required";
        extraControlsError = true;
      }

      const parsedMaxRows = parseInt(this.quickFindMaxRowsInputValue);
      if (isNaN(parsedMaxRows)) {
        this.quickFindMaxRowsErrorMessage = "Enter a number";
        extraControlsError = true;
      }
      if (parsedMaxRows < 0) {
        this.quickFindMaxRowsErrorMessage = "Enter a non-negative number";
        extraControlsError = true;
      }

      if (error || extraControlsError) {
        return;
      }

      // format filters description
      this.quickFindFiltersExtraSpaceText = `Search by ${inputs["searchBy"]["Search"]} ${inputs["searchCriteria"]["Criteria"]} `;
      switch (inputs["searchBy"]["ControlType"]) { // might add other control types in the future
        case "Input":
          this.quickFindFiltersExtraSpaceText += `${inputs["searchValue"]}, `;
          break;

        case "DateTimePicker":
          this.quickFindFiltersExtraSpaceText += `${inputs["searchValue"].formatString("yyyy-MM-dd")}, `;
          break;
      }
      this.quickFindFiltersExtraSpaceText += `view ${this.quickFindViewOptionDropdownSelectedObject["ViewOption"]} consignments`;
      if (this.quickFindMaxRowsInputValue !== "0") {
        this.quickFindFiltersExtraSpaceText += `, max ${this.quickFindMaxRowsInputValue} records`;
      }

      this.quickFindButtonFilterIsOpen = false; // close button filter popup
      this.quickFindResultsTableBoxData = [];
      this.$fullscreenLoading("Getting Consignment Notes");

      let response = await this.$apiCallV2("/VehicleSchedule/QuickFind", {
        "searchby": inputs["searchBy"]["Search"],
        "criteria": inputs["searchCriteria"]["Criteria"],
        "value": inputs["searchValue"],
        "viewoption": this.quickFindViewOptionDropdownSelectedObject["ViewOption"],
        "top": this.quickFindMaxRowsInputValue !== "0" ? this.quickFindMaxRowsInputValue : "", // leave blank if 0 is entered
      });
      response = response.map((consignment) => {
        if (consignment["Status"] === "Canceled") {
          consignment["#"] = `<img src="https://dsmlib.logistics.systems/Icons/Cross.png" alt="Canceled" style="height: 20px; width: 20px;"> ${consignment["#"]}`;
        } else {
          consignment["#"] = `<span style="margin-left: 20px;">${consignment["#"]}</span>`;
        }

        if (consignment["B2B"] === "Yes") {
          consignment["B2B"] = `<img src="https://dsmlib.logistics.systems/Icons/icons8-done-64.png" alt="Yes" style="height: 20px; width: 20px;"> Yes`;
        }

        return consignment;
      });

      this.$fullscreenLoading();
      this.$nextTick(() => {
        this.quickFindResultsTableBoxData = response;
      });
      
    },
    quickFindSelectClicked: async function(selectedRow) {
      if (selectedRow.length === 0) { // if no row is selected
        this.$showAlert("error", "No Consignment Note Selected", "Select a consignment note before proceeding", [{"text": "OK"}]);
        return;
      }

      this.$fullscreenLoading("Getting Consignment Details");
      const response = await this.$apiCallV2(`/VehicleSchedule/GetHMSTripDetails?consignmentno=${selectedRow[0]["Consignment #"].trim()}`);
      this.$fullscreenLoading();

      this.assignData = response[0];
      this.rightMenuShow = true;

      this.hideConsignmentDetails(); // hide consignmentDetails pane

      // there are methods that do the exact same as the lines below
      // the portDepotTripListBackClicked and portDepotHomeBackClicked methods
      // not using those because they might be modified to do more things in the future, and not just hide each pane
      this.$set(this.consignmentSelection, 'select', ''); // hide consignment selection screen for port/depot booking
      this.$set(this.consignmentSelection, 'show', false); // hide port/depot booking home pane 

      this.radioCallTabShow = false; // hide HMSUpdateStatusTask component
      this.rightMenuHomeSelectedIndex = { // reset rightMenuHomeSelectedIndex to unselect consignment
        "tripType": "",
        "index": -1,
      };
      this.selectedWhiteContainer = null; // unselect consignment
      this.showAssignPanel = true;
      this.showQuickFindPopup = false;
    },
    closeRightMenu: async function() {
      if (this.radioCallTabShow && !(await this.radioCallDiscardAttachments())) {
        // if PUI/PUO/DOI/DOO tab is shown and user does not want to discard newly uploaded attachments, don't close the RightMenu
        return;
      }

      this.showAssignPanel = false; // hide AssignV3 component
      this.hideConsignmentDetails(); // hide consignmentDetails pane

      // there are methods that do the exact same as the lines below
      // the portDepotTripListBackClicked and portDepotHomeBackClicked methods
      // not using those because they might be modified to do more things in the future, and not just hide each pane
      this.$set(this.consignmentSelection, 'select', ''); // hide consignment selection screen for port/depot booking
      this.$set(this.consignmentSelection, 'show', false); // hide port/depot booking home pane 

      this.radioCallTabShow = false; // hide HMSUpdateStatusTask component
      this.rightMenuHomeSelectedIndex = { // reset rightMenuHomeSelectedIndex to unselect consignment
        "tripType": "",
        "index": -1,
      };
      this.selectedWhiteContainer = null; // unselect consignment
      this.showRightMenuHome = false;
      this.rightMenuShow = false;
      this.radioCallUpdateSuccess = null;
      this.radioCallResultMessage = '';
      this.radioCallAttachmentsChanged = false;
    },
    moreActionsEditTripButtonClicked: async function(pointerEvent) {
      if (!this.selectedWhiteContainer) { // the button should be disabled if no trip is selected, but i'm handling it just in case
        this.$showAlert("error", "No Trip Selected", "Select a trip to edit", [{"text": "OK"}]);
        return;
      }

      this.showMoreActionsMenu = false;
      this.$fullscreenLoading(`Getting ${this.selectedWhiteContainer["ConsignmentNo"]} Trip Details (${this.selectedWhiteContainer["MovementType"]})`);
      let response = (
        await this.$apiCallV2(
          `/VehicleSchedule/GetHMSTripDetails?consignmentno=${this.selectedWhiteContainer["ConsignmentNo"]}` +
          `&journeyguid=${this.selectedWhiteContainer["JourneyGUID"]}`
        )
      )[0];
      response["_tripHasBeenCompleted"] = this.rightMenuHomeSelectedIndex["tripType"] === "Historical";
      this.$fullscreenLoading();

      this.assignData = response;
      this.rightMenuShow = true;
      this.showAssignPanel = true;
    },
    moreActionsDeleteTripButtonClicked: function(pointerEvent) {
      if (!this.selectedWhiteContainer) { // the button should be disabled if no trip is selected, but i'm handling it just in case
        this.$showAlert("error", "No Trip Selected", "Select a trip to delete", [{"text": "OK"}]);
        return;
      }

      this.showMoreActionsMenu = false;
      if (this.rightMenuHomeSelectedIndex["tripType"] === "Historical") { // button is enabled, need to handle
        this.$showAlert(
          "error",
          "Completed Trip Selected",
          `The trip ${this.selectedWhiteContainer["ConsignmentNo"]} (${this.selectedWhiteContainer["MovementType"]}) is already complete.<br>You cannot delete completed trips`,
          [{"text": "OK"}]
        );
        return; // adding a popup is better than just disabling the button, so that users know why they can't delete
      }

      this.deleteTripPopupReasonInputValue = "";
      this.deleteTripPopupReasonInputErrorMessage = "";
      this.showDeleteTripPopup = true;
      this.showMoreActionsMenu = false;
    },
    deleteTripPopupButtonClicked: async function(buttonText) {
      if (buttonText === "Cancel") {
        this.showDeleteTripPopup = false;
        return;
      }

      if (this.deleteTripPopupReasonInputValue.trim() === "") {
        this.deleteTripPopupReasonInputErrorMessage = "Please enter your reason";
        return;
      }

      this.$fullscreenLoading(`Deleting ${this.selectedWhiteContainer["ConsignmentNo"]} trip (${this.selectedWhiteContainer["MovementType"]})`);

      const deleteTripResponse = await this.$apiCallV2("/VehicleSchedule/HMSUpdateTrip", {
        "action": "D",
        "cn": this.selectedWhiteContainer["ConsignmentNo"],
        "journeyguid": this.selectedWhiteContainer["JourneyGUID"],
        "delreason": this.deleteTripPopupReasonInputValue.trim(),
      });

      // assuming it always returns an array
      if (deleteTripResponse[0]["Results"] === 0 || deleteTripResponse[0]["Results"] === "0") {
        this.$showAlert(
          "success",
          "Trip Deleted",
          `${this.selectedWhiteContainer["ConsignmentNo"]} Trip (${this.selectedWhiteContainer["MovementType"]}) successfully deleted`,
          [{"text": "OK"}]
        );

        this.rightMenuHomeSelectedIndex = { // reset rightMenuHomeSelectedIndex to unselect consignment
          "tripType": "",
          "index": -1,
        };
        this.selectedWhiteContainer = null; // unselect consignment

        if (this.showPendingTrips) { // if the pending trips box is expanded
          this.pendingTripsIsLoading = true;
          this.pendingTrips = await this.getDriverTrips(this.selectedDriver, 0); // refresh trips instantly
          this.pendingTripsIsLoading = false;
        } else { // if the pending trips box is collapsed
          this.pendingTrips = []; // just clear the list, it will be refreshed the next time the box is expanded
        }

        // no need to refresh historical trips since users can't delete completed trips
        await this.getGanttDetails();
      } else {
        this.$showAlert(
          "error",
          "Error Deleting Trip",
          deleteTripResponse[0]["ErrMsg"] || `An error occurred while deleting ${this.selectedWhiteContainer["ConsignmentNo"]} Trip (${this.selectedWhiteContainer["MovementType"]})`,
          [{"text": "OK"}]
        );
      }
      this.$fullscreenLoading();
      this.showDeleteTripPopup = false;
    },
    cancelPortBooking : async function (e) {
      this.cancelBookingID = '';
      this.cancelBookingJourneyGUID = '';
      this.cancelBookingB2BJourneyGUID = '';
      this.cancelBookingNotes = '';
      this.showCancelBookingPopup = true;
      this.showMoreActionsMenu = false;
      this.selectedWhiteContainer = this.$jsonNullToStringV2(this.$deepTrimJsonV3(this.selectedWhiteContainer));
      this.cancelBookingID = this.selectedWhiteContainer['cmbookid'];
      this.cancelBookingJourneyGUID = this.selectedWhiteContainer['JourneyGUID'];
      this.cancelBookingB2BJourneyGUID = this.selectedWhiteContainer['B2BJourneyGUID'];
    },

    cancelPortBookingClicked : async function (e) { 
      switch(e) {
        case 'Delete':
          if (!this.cancelBookingNotes) {
            await this.$showAlert('error', 'Missing Info', 'Must provide reason for cancellation of booking.', [
              { text: 'Ok', color: 'green', textColor: 'White' },
            ]);
            return;
          }

          this.selectedWhiteContainer = this.$jsonNullToStringV2(this.$deepTrimJsonV3(this.selectedWhiteContainer));
          const dataToPost = {
            journeyguid : this.selectedWhiteContainer['JourneyGUID'],
            b2bjourneyguid : this.selectedWhiteContainer['B2BJourneyGUID'],
            bookingid : this.selectedWhiteContainer['cmbookid'],
            notes : this.cancelBookingNotes,
          }
          let result =  await this.$apiCallV2(`/VehicleSchedule/CancelPortBooking`, dataToPost);

          if (result[0]['Results'] > 0) {
            await this.$showAlert('error', 'Failed to cancel booking', `${result[0]['ErrMsg']}`, [
              { text: 'Ok', color: 'green', textColor: 'white' },
            ]);
          } else if (result[0]['Results'] == 0) {
            await this.$showAlert('success', 'Successfully cancel booking', `${result[0]['ErrMsg']}`, [
              { text: 'Ok', color: 'green', textColor: 'white' },
            ]);
          }

          this.cancelBookingID = '';
          this.cancelBookingJourneyGUID = '';
          this.cancelBookingB2BJourneyGUID = '';
          this.cancelBookingNotes = '';
          this.showCancelBookingPopup = false;

          this.pendingTrips = [];
          this.pendingTripsIsLoading = true;
          this.pendingTrips = await this.getDriverTrips(this.selectedDriver, 0);
          this.pendingTripsIsLoading = false;
          break;
        case 'Cancel':
          this.cancelBookingID = '';
          this.cancelBookingJourneyGUID = '';
          this.cancelBookingB2BJourneyGUID = '';
          this.cancelBookingNotes = '';
          this.showCancelBookingPopup = false;
          break;
      }
    },

    radioCallStatusUpdated: function(e, data, title, hasSaved) {
      if (hasSaved) this.refreshVehicleTaskCount();
       // scenario : 1 failed, 1 succeed will still counted as success
      this.radioCallUpdateSuccess = hasSaved;
      if (hasSaved) {
        this.radioCallResultMessage = `Successfully updated [${title}] status`;
      } else {
        this.radioCallResultMessage = data[0]['ErrMsg'] || data[1]['ErrMsg'];
      }
    },
    radioCallStatusReversed: function(results) { // results variable contains responses from API
      this.refreshVehicleTaskCount();
      let success = [];
      let failure = "";
      for (const r of results) {
        if (r["Response"]["Results"] === 0) { // reversed successfully
          success.push(r["Reversed Status"]);
        } else { // reversed unsuccessfully (at most there will only be one, because it stops reversing after the first failure, and it should always be the first element in Results)
          failure = r["Reversed Status"];
        }
      }

      if (failure === "") { // no failures
        this.radioCallUpdateSuccess = true;
        this.radioCallResultMessage = `Successfully reversed ${success.join(", ")}`;
      } else { // 1 failure (at most only one, because it stops reversing after the first failure)
        this.radioCallUpdateSuccess = false;
        if (success.length == 0) { // no successes
          this.radioCallResultMessage = `Failed to reverse ${failure}`;
        } else {
          this.radioCallResultMessage = (
            "Failed to reverse some statuses<br/>" +
            `Success: ${success.join(", ")}<br/>` +
            `Failure: ${failure}`
          );
        }
      }
    },
    radioCallDiscardAttachments: async function() {
      if (this.radioCallAttachmentsChanged) { // if there are newly uploaded attachments
        const response = await this.$showAlert( // prompt user to find out if they want to discard or not
          "warning",
          "Unsaved Attachments",
          "You have unsaved attachments.<br>Are you sure you want to discard them?",
          [
            { text: "Discard" },
            { text: "Cancel", color: "lightgray" },
          ]
        );

        return response == "Discard";
      }

      return true; // there are no newly uploaded attachments
    },
    radioRadioBackClicked: async function(pointerEvent) {
      if (!(await this.radioCallDiscardAttachments())) {
        // if user does not want to discard newly uploaded attachments, don't go back to the trip list screen
        return;
      }

      this.radioCallTabShow = false;
      this.radioCallAttachmentsChanged = false;
      this.rightMenuHomeSelectedIndex = { // reset rightMenuHomeSelectedIndex to unselect consignment
        "tripType": "",
        "index": -1,
      };
      this.selectedWhiteContainer = null;
      this.radioCallResultMessage = '';
      this.radioCallUpdateSuccess = null;

      // refresh regardless of whether there was a successful operation or not
      if (this.showPendingTrips || this.pendingTrips.length > 0) { // if pending trips is shown or the array isn't blank
        this.$fullscreenLoading(`Refreshing Pending Trips for Driver ${this.selectedDriver}`); // refresh pending trips
        this.pendingTrips = [];
        this.pendingTrips = await this.getDriverTrips(this.selectedDriver, 0);
      }
      if (this.showTripsHistory || this.tripsHistory.length > 0) { // if trips history is shown or the array isn't blank
        this.$fullscreenLoading(`Refreshing Trips History for Driver ${this.selectedDriver}`); // refresh historical trips
        this.tripsHistory = [];
        this.tripsHistory = await this.getDriverTrips(this.selectedDriver, 1);
      }
      this.$fullscreenLoading();
    },
    radioCallButtonClicked : function (e) {
      this.consignmentDetails = null;
      this.$set(this.consignmentSelection, 'show', false);
      this.$set(this.consignmentSelection, 'upperSelected', null);
      this.$set(this.consignmentSelection, 'lowerSelected', null);
      this.$set(this.consignmentSelection, 'select', '');
      this.radioCallTabShow = true;
      this.radioCallUpdateSuccess = null;
    },
    getGanttDetails: async function() {
      this.ganttItems = [];
      this.filteredGanttItems = [];
      const items = await this.$apiCallV2(`/VehicleSchedule/GanttViewTASV2?start=${this.startDate.formatString('yyyy-MM-dd HH:mm')}&end=${this.endDate.formatString('yyyy-MM-dd HH:mm')}&viewType=TEAM_PM`);
      if (!Array.isArray(items)) return;
      this.ganttItems = items.map(item => Object.assign({}, item, {
        cid: JSON.stringify([String(item.vehicleCode || item.ccol1text || '').trim(), String(item.cid || '').trim()])
      }));
      if (this.selectedVehicleCode) {
        this.setVehicleTaskScope(this.ganttItems.filter(item => `${item.pid || ''}:${item.cid || ''}` === this.selectedGanttRowKey));
      }
      this.lastRefresh = new Date().formatString('yyyy-MM-dd HH:mm');

      if (this.refreshTimeStart > 0) {
        this.refreshIntervalClicked(null, this.refreshTimeStart);
      }
      
      this.filterPMTeam(this.selectedPMTeams);
    },
    ganttZoomChanged: function(interval) {
      this.ganttInterval = interval;
    },
    ganttRowClicked: async function(e) {
      const row = e && e[0];
      if (!row) return;
      const vehicleLabel = String(row.ccol1text || '').trim();
      const vehicleMatch = vehicleLabel.match(/^\[([^\]]*)\]\s*(.*)$/);
      const vehicleParts = vehicleMatch ? [vehicleMatch[2].trim(), vehicleMatch[1].trim()] : vehicleLabel.split('-');
      const vehicleCode = vehicleParts[0];
      const vehicleNumber = vehicleParts[1] || '';
      const driverText = String(row.ccol2text || '');
      if (!vehicleCode) {
        this.$showAlert('warning', 'Vehicle Unavailable', 'This row has no vehicle code. Refresh the schedule and try again.');
        return;
      }
      this.selectedGanttRowKey = `${row.pid || ''}:${row.cid || ''}`;
      // hide consignment details
      this.consignmentDetails = null;

      // hide and reset port booking & depot booking
      this.$set(this.consignmentSelection, 'show', false);
      this.$set(this.consignmentSelection, 'upperSelected', null);
      this.$set(this.consignmentSelection, 'lowerSelected', null);
      this.$set(this.consignmentSelection, 'select', '');

      // hide HMSUpdateStatusTask component
      this.radioCallTabShow = false;

      // show pending trips
      this.showPendingTrips = true;
      this.pendingTripsIsLoading = true;
      this.pendingTrips = [];

      // hide historical trips
      this.showTripsHistory = false;
      this.tripsHistoryIsLoading = false;
      this.tripsHistory = [];

      // reset rightMenuHomeSelectedIndex to unselect consignment
      this.rightMenuHomeSelectedIndex = {
        "tripType": "",
        "index": -1,
      };
      this.selectedWhiteContainer = null;

      this.showRightMenuHome = true; // screen showing all trips, the first page shown after clicking on a row on the gantt chart
      this.rightMenuShow = true; // show right menu
      this.hmsTitle = [vehicleCode + (vehicleNumber ? ` (${vehicleNumber})` : ''), driverText.replace(/[\[\]]/g, '')].filter(Boolean).join(' - ');
      this.selectedVehicleCode = vehicleCode;
      this.selectedDriver = (String(driverText).match(/\[([^\]]+)\]/) || [])[1] || '';
      this.setVehicleTaskScope(e);

      const rowKey = this.selectedGanttRowKey;
      try {
        const trips = await this.getDriverTrips(this.selectedDriver, 0);
        if (this.selectedGanttRowKey === rowKey) this.pendingTrips = trips;
      } finally {
        if (this.selectedGanttRowKey === rowKey) this.pendingTripsIsLoading = false;
      }
    },


    setVehicleTaskScope: function(items) {
      this.vehicleTaskJourneyGuids = items
        .map(item => String(item.RefGUID || '').trim())
        .filter((guid, index, guids) => guid && guids.findIndex(other => other.toLowerCase() === guid.toLowerCase()) === index);
    },
    refreshVehicleTaskCount: async function() {
      const request = this.vehicleTaskRequest;
      const requestKey = JSON.stringify(request);
      const vehiclecode = request.vehiclecode;
      const revision = ++this.vehicleTaskCountRevision;
      this.vehicleTaskCount = 0;
      if (!vehiclecode) { this.vehicleTaskCount = 0; return; }
      try {
        const response = await this.$apiCallV2('/Vehicle/GetVehicleScheduleTasks', { ...request, countonly: true }, 'post', null, false);
        const result = Array.isArray(response) ? response[0] : response;
        if (revision === this.vehicleTaskCountRevision && requestKey === JSON.stringify(this.vehicleTaskRequest)) {
          this.vehicleTaskCount = result && String(result.Results) === '0' ? Number(result.PendingTaskCount) || 0 : 0;
        }
      } catch (error) {
        if (revision === this.vehicleTaskCountRevision && requestKey === JSON.stringify(this.vehicleTaskRequest)) this.vehicleTaskCount = 0;
      }
    },
    openVehicleTasks: async function() {
      this.showMoreActionsMenu = false;
      if (this.vehicleTaskRequest.vehiclecode) await this.$refs.vehicleTasksPopup.open(this.vehicleTaskRequest);
    },
    getDriverTrips : async function (driverCode, finish) {
      const tripsUrl = `/VehicleSchedule/GetHMSTripsByDriver?driver=${encodeURIComponent(driverCode)}&finish=${finish}`;
      if (!driverCode) return [];
      if (finish == 1) { // finish is set to 1
        const trips = await this.$apiCallV2(tripsUrl);
        return Array.isArray(trips) ? trips : [];
      } // no need to get booking status from CargoMove, since the trip is already completed

      let hmsTrip = await this.$apiCallV2(tripsUrl); // GET ALL TRIPS GUID
      if (Array.isArray(hmsTrip)) {
        hmsTrip.forEach(async (data) => {
          if (data['cmbook']) { // if cmbook is set, call PortBooking with "booking" field set to "STATUS"
            const dataToPost = {
              journeyguid : data['JourneyGUID'].trim(),
              b2bjourneyguid : !data['B2BJourneyGUID'] ? '' : data['B2BJourneyGUID'].trim(),
              bookingid : data['cmbookid'].trim()
            }
            await this.$apiCallV2(`/VehicleSchedule/GetPortBookingStatus`, dataToPost);
          }

        });
        const trips = await this.$apiCallV2(tripsUrl);
        return Array.isArray(trips) ? trips : [];
      }
      return [];
    },
    togglePendingTrips: async function(pointerEvent) {
      this.showPendingTrips = !this.showPendingTrips;

      if (this.showPendingTrips && this.pendingTrips.length == 0) {
        this.pendingTripsIsLoading = true;
        this.pendingTrips = await this.getDriverTrips(this.selectedDriver, 0);
        this.pendingTripsIsLoading = false;
      }
    },
    toggleTripsHistory: async function(pointerEvent) {
      this.showTripsHistory = !this.showTripsHistory;

      if (this.showTripsHistory && this.tripsHistory.length == 0) {
        this.tripsHistoryIsLoading = true;
        this.tripsHistory = await this.getDriverTrips(this.selectedDriver, 1);
        this.tripsHistoryIsLoading = false;
      }
    },
    portDepotTripListBackClicked: function() {
      this.$set(this.consignmentSelection, 'select', '');
    },
    portDepotHomeBackClicked: function() {
      this.$set(this.consignmentSelection, 'show', false);
    },

    showConsignmentDetails: async function(hmsTrip, actionToRevert) { // switch to the details screen
      // this.hmsTitle = details['ConsignmentNo'] ? details['ConsignmentNo'].trim() : '';
      this.consignmentDetails = hmsTrip // the screen automatically shows if consignmentDetails is not null

      // clicking on the show details tooltip will also click the consignment it is on, leading to unwanted inputs
      switch (actionToRevert) { // this switch statement reverts those actions
        case "pendingHistoricalTripSelect":
          const copyOfSelectedIndex = {...this.rightMenuHomeSelectedIndex}; // make a copy of the current selected index
          const copyOfSelectedWhiteContainer = this.selectedWhiteContainer ? {...this.selectedWhiteContainer} : null;
          setTimeout(() => {
            this.rightMenuHomeSelectedIndex = copyOfSelectedIndex; // and assign it back later
            this.selectedWhiteContainer = copyOfSelectedWhiteContainer;
          }, 300); // this.$nextTick() doesn't work, needs to be setTimeout()
          break;

        case "portDepotTripSelect":
          const copyOfSelectionType = this.consignmentSelection["select"];
          const copyOfUpperSelected = (
            this.consignmentSelection["upperSelected"] ?
            {...this.consignmentSelection["upperSelected"]} :
            null
          );
          const copyOfLowerSelected = (
            this.consignmentSelection["lowerSelected"] ? 
            {...this.consignmentSelection["lowerSelected"]} :
            null
          );
          setTimeout(() => {
            this.$set(this.consignmentSelection, "upperSelected", copyOfUpperSelected);
            this.$set(this.consignmentSelection, "lowerSelected", copyOfLowerSelected);
            this.$set(this.consignmentSelection, "select", copyOfSelectionType);
          }, 300);
          break;

        case "portDepotShowTripList":
          setTimeout(() => {
            this.$set(this.consignmentSelection, "select", "");
          }, 300);
          break;
      }
    },
    hideConsignmentDetails: function() {
      //-- Reset Port Booking (with conditions)
      // if (!this.consignmentSelection['show'] && !this.consignmentDetails) {
      //   this.$set(this.consignmentSelection, 'show', true);
      //   this.$set(this.consignmentSelection, 'select', '');
      // } else if (this.consignmentSelection['select'] == '' && !this.consignmentDetails) {
      //   this.$set(this.consignmentSelection, 'show', false);
      //   this.$set(this.consignmentSelection, 'upperSelected', null);
      //   this.$set(this.consignmentSelection, 'lowerSelected', null);
      //   this.$set(this.consignmentSelection, 'select', '');
      //   this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
      //   this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
      // }
      
      //-- Close details
      this.consignmentDetails = null; // the screen automatically hides if consignmentDetails is null
    },
    formatConsignmentDetailsAddress: function(type) { // formats ToAddress and FromAddress displayed on the consignment details screen
      // address needs to be formatted as:
      // ToAddress
      // PostCode City, State, Country
      
      // type passed into the method is either 'From' or 'To'
      // use string interpolation to get field to access

      let address = this.consignmentDetails[`${type}Address`] ? this.consignmentDetails[`${type}Address`].replace(/\r/g, '<br>').trim() : '<br>';
      // replace all \r in address with a line break (<br>)
      address += address.endsWith('<br>') ? '' : '<br>';
      // if address already ends with a line break, don't add another one

      address += this.consignmentDetails[`${type}PostCode`] ? `${this.consignmentDetails[type + 'PostCode']} ` : '';
      address += this.consignmentDetails[`${type}City`] ? `${this.consignmentDetails[type + 'City']}, ` : (this.consignmentDetails[`${type}PostCode`] ? ', ' : '');
      // don't add a comma if there is no PostCode and City
      
      address += this.consignmentDetails[`${type}State`];
      address += this.consignmentDetails[`${type}State`] ? `, ${this.consignmentDetails[type + 'Country']}` : this.consignmentDetails[type + 'Country'];
      // if state isn't blank, add a comma and append country, else just add country

      return address;
      // in the HTML template, the returned string is placed inside a v-html tag, so Vue.js treats it as HTML instead of a plain string and renders it accordingly
    },
    refreshCountdown: async function() {
      this.refreshTime--;
      if (this.refreshTime < 0) {
        this.refreshTime = this.refreshTimeStart;
      } else if (this.refreshTime == 0) {
        this.$fullscreenLoading('Getting Details');
        await this.getGanttDetails();
        this.$fullscreenLoading();
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    refreshIntervalClicked: async function(e, seconds) {
      if (seconds) {
        this.refreshTime = seconds;
        if (e) { this.refreshTimeStart = seconds };
        if (this.refreshInterval) {
          clearInterval(this.refreshInterval);
        }

        this.refreshInterval = setInterval(this.refreshCountdown, 1000);
      } else {
        if (e) {
          this.$fullscreenLoading('Getting Details');
          await this.getGanttDetails();
          this.$fullscreenLoading();
        } else {
          clearInterval(this.refreshInterval);
          this.refreshInterval = null;
          this.refreshTimeStart = 0;
        }
      }

      this.showRefreshDropdown = false;
    },
    onRefreshDropdownMouseDown: function(event) {
      if (this.$refs.refreshContainer && this.$refs.refreshContainer.contains(event.target)) {
        return;
      }
      this.showRefreshDropdown = false;
    },

    hmsHideTrip(trip) { // determines whether to hide a trip or not on the consignment selection screen
      let trigger = false; // hide if it has already been selected

      if (this.consignmentSelection['upperSelected']) {
        if ((this.consignmentSelection['upperSelected']['ConsignmentNo'] == trip['ConsignmentNo']) && (this.consignmentSelection['upperSelected']['MovementType'] == trip['MovementType'])) {
          trigger = true;
        }
      }

      if (this.consignmentSelection['lowerSelected']) {
        if ((this.consignmentSelection['lowerSelected']['ConsignmentNo'] == trip['ConsignmentNo']) && (this.consignmentSelection['lowerSelected']['MovementType'] == trip['MovementType'])) {
          trigger = true;
        }
      }

      return trigger;
    },

    pendingTripClicked: function(trip, index) {
      if (this.rightMenuHomeSelectedIndex["tripType"] == "Pending" && this.rightMenuHomeSelectedIndex["index"] == index) {
        this.rightMenuHomeSelectedIndex["tripType"] = "";
        this.rightMenuHomeSelectedIndex["index"] = -1;
        this.selectedWhiteContainer = null;
      } else {
        this.rightMenuHomeSelectedIndex["tripType"] = "Pending";
        this.rightMenuHomeSelectedIndex["index"] = index;
        this.selectedWhiteContainer = trip;
      }
    },
    historicalTripClicked: function(trip, index) {
      if (this.rightMenuHomeSelectedIndex["tripType"] == "Historical" && this.rightMenuHomeSelectedIndex["index"] == index) {
        this.rightMenuHomeSelectedIndex["tripType"] = "";
        this.rightMenuHomeSelectedIndex["index"] = -1;
        this.selectedWhiteContainer = null;
      } else {
        this.rightMenuHomeSelectedIndex["tripType"] = "Historical";
        this.rightMenuHomeSelectedIndex["index"] = index;
        this.selectedWhiteContainer = trip;
      }
    },
    portBookingButtonClicked: function(pointerEvent) {
      this.rightMenuHomeSelectedIndex = { // reset rightMenuHomeSelectedIndex to unselect consignment
        "tripType": "",
        "index": -1,
      };
      this.selectedWhiteContainer = null;
      this.hideConsignmentDetails();
      this.mode = 'Port Booking'; // populate fields accordingly and show consignment selection screen
      this.$set(this.consignmentSelection, 'upperLabel', 'Export');
      this.$set(this.consignmentSelection, 'upperSelected', null);
      this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
      this.$set(this.consignmentSelection, 'lowerLabel', 'Import');
      this.$set(this.consignmentSelection, 'lowerSelected', null);
      this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
      this.$set(this.consignmentSelection, 'show', true);
      this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
      this.$set(this.consignmentBook, 'timeoutInterval', null);
    },
    depotBookingButtonClicked: async function(pointerEvent) {
      this.rightMenuHomeSelectedIndex = { // reset rightMenuHomeSelectedIndex to unselect consignment
        "tripType": "",
        "index": -1,
      };
      this.selectedWhiteContainer = null;
      this.hideConsignmentDetails();
      if (this.depotDropdownItems.length == 0) { // if this is the first time user clicked on depot booking
        this.$set(this.consignmentSelection, 'loadingMsg', 'Getting Depots');
        this.$set(this.consignmentSelection, 'loading', true);

        // call API to get Depots
        let GetCMRecordsResponse = await this.$apiCallV2('/VehicleSchedule/GetCMRecords');
        if (GetCMRecordsResponse.length == 0) {
          // this.$alert.showAlert('No Available Depot', 'Please try again later', 'error');
          this.$showAlert("error", "No Available Depots", "There are no available depots. Please try again later.", [{"text": "OK"}]);
          this.$set(this.consignmentSelection, 'loading', false);
          return;
        } else {
          // populate Dropdown items
          this.depotDropdownItems = GetCMRecordsResponse['depots'].map((depot) => {
            return {
              'name': depot['name'],
              'fullname': depot['fullname'],
              'operators': depot['operators'].map((operator) => { return {'operator':operator} })
            };
          });
        }
        // only call the API to get Depots the first time depot booking is clicked
        // subsequent depot booking clicks won't call the API again

        this.$set(this.consignmentSelection, 'loading', false);
      }

      this.mode = 'Depot Booking'; // populate fields accordingly and show consignment screen
      this.$set(this.consignmentSelection, 'upperLabel', 'Dropoff');
      this.$set(this.consignmentSelection, 'upperSelected', null);
      this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
      this.$set(this.consignmentSelection, 'lowerLabel', 'Pickup');
      this.$set(this.consignmentSelection, 'lowerSelected', null);
      this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
      this.$set(this.consignmentSelection, 'show', true);
      this.depotDropdownSelected = null; // clear Dropdown selected item if any
    },
    portDepotBookingShowTrips: async function(movementType) {
      if (this.pendingTrips.length == 0) { // call API to get pending trips if the array is empty
        this.$set(this.consignmentSelection, 'loadingMsg', 'Getting Pending Trips');
        this.$set(this.consignmentSelection, 'loading', true);
        this.pendingTrips = await this.getDriverTrips(this.selectedDriver, 0);
        this.$set(this.consignmentSelection, 'loading', false);
      }

      switch (movementType) {
        case 'upper':
          this.$set(this.consignmentSelection, 'select', (this.mode == 'Port Booking') ? 'export' : 'dropoff');
          break;

        case 'lower':
          this.$set(this.consignmentSelection, 'select', (this.mode == 'Port Booking') ? 'import' : 'pickup');
          break;
      }

      this.$set(this.consignmentSelection, movementType + 'Msg', { 'status': 0, 'errMsg': '' });
    },
    portDepotBookingTripSelected: function(trip, index) {
      switch (this.consignmentSelection["select"]) {
        case "export":
        case "dropoff":
          this.$set(this.consignmentSelection, "upperSelected", trip);
          break;

        case "import":
        case "pickup":
          this.$set(this.consignmentSelection, "lowerSelected", trip);
          break;

        default:
          if (process.env['NODE_ENV'] == 'development') {
            console.error("[VehicleSchedulePageV4] Invalid select value, check that consignmentSelection['select'] is populated properly");
            console.trace();
          }
      }

      this.$set(this.consignmentSelection, 'select', '');
      this.$set(this.consignmentSelection, 'show', true);
    },
    resetUpperSelection: function(pointerEvent) { // reset upper consignment selection (export/dropoff) in port-depot-booking-home
      this.$set(this.consignmentSelection, 'upperSelected', null);
      this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
    },
    resetLowerSelection: function(pointerEvent) { // reset lower consignment selection (import/pickup) in port-depot-booking-home
      this.$set(this.consignmentSelection, 'lowerSelected', null);
      this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
    },
    resetUpperLowerSelection: function(pointerEvent) { // reset both consignment selections in port-depot-booking-home
      this.$set(this.consignmentSelection, 'upperSelected', null);
      this.$set(this.consignmentSelection, 'lowerSelected', null);
      this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
      this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
      this.depotDropdownSelected = null;
    },

    getAvailableTrailers: async function() {
      let availableTrailers = await this.$apiCallV2("/VehicleSchedule/GetVehicleListByCategory?vehiclecategory=TR&available=1");
      availableTrailers = availableTrailers.map((trailer) => {
        return {
          ...trailer,
          "description": `${trailer['VehicleNo']} (${trailer['orivehicleno'] || trailer['VehicleCode']}) (${trailer['VehicleLength']})`,
        };
      });
      return availableTrailers;
    },
    verifyTrip: async function() { // verify that the trips selected are valid for booking
      switch (this.mode) { // the button is used for both port booking and depot booking
        case 'Port Booking': // if the user is performing a port booking
          this.$set(this.consignmentSelection, 'portbookType', `${this.consignmentSelection['upperSelected'] ? 'upper' : ''}${this.consignmentSelection['lowerSelected'] ? 'lower' : ''}`);

          this.$nextTick(async () => {
            this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': '' });
            this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': '' });
            this.$set(this.consignmentBook['content'], 'popupData', { 'timeout': 300, 'loadText': '', 'jobs': [], 'trailers': [] });

            //-- Set Loading
            this.$set(this.consignmentSelection, 'loadingMsg', 'Verifying');
            this.$set(this.consignmentSelection, 'loading', true);

            switch(this.consignmentSelection['portbookType']) {
              case 'upperlower':
                //-- Set variables
                var reqCount = 0;

                //-- Verify Data (export)
                var dataToPostExport = {
                  'server': 'production',
                  'journeyguid': this.consignmentSelection['upperSelected']['JourneyGUID'] ? this.consignmentSelection['upperSelected']['JourneyGUID'].trim() : '',
                  'addjourneyguid': '',
                  'bookingtype': 'export',
                  'action': '',
                  'terminal': '',
                  'timeslot': '',
                  'notes': ''
                }

                var requestExport = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPostExport);

                //-- Verify Data (import)
                var dataToPostImport = {
                  'server': 'production',

                  'journeyguid': this.consignmentSelection['lowerSelected']['JourneyGUID'] ? this.consignmentSelection['lowerSelected']['JourneyGUID'].trim() : '',
                  'addjourneyguid': '',
                  'bookingtype': 'import',
                  'action': '',
                  'terminal': '',
                  'timeslot': '',
                  'notes': ''
                }

                var requestImport = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPostImport);

                //-- Check incoming data
                //-- EXPORT
                if (!Array.isArray(requestExport) && (typeof requestExport == 'object')) {
                  this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': 'Available for Booking' });
                  reqCount += 1;
                } else if (Array.isArray(requestExport)) {
                  if (requestExport[0]['Results'] > 0) {
                    this.$set(this.consignmentSelection, 'upperMsg', { 'status': 1, 'errMsg': requestExport[0]['ErrMsg'] });
                  }
                }

                //-- IMPORT
                if (!Array.isArray(requestImport) && (typeof requestImport == 'object')) {
                  this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': 'Available for Booking' });
                  reqCount += 1;
                } else if (Array.isArray(requestImport)) {
                  if (requestImport[0]['Results'] > 0) {
                    this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 1, 'errMsg': requestImport[0]['ErrMsg'] });
                  }
                }

                if (reqCount >= 2) {
                  //-- Set Popup title
                  var impExp = 'EXP';
                  var consignmentNo = this.consignmentSelection['upperSelected']['ConsignmentNo'] ? this.consignmentSelection['upperSelected']['ConsignmentNo'].trim() : 'Consignment #';
                  var containerNo = this.consignmentSelection['upperSelected']['ContainerNo'] ? this.consignmentSelection['upperSelected']['ContainerNo'].trim() : 'Container #';

                  var title = 'Port Booking - [' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ';

                  impExp = 'IMP';
                  consignmentNo = this.consignmentSelection['lowerSelected']['ConsignmentNo'] ? this.consignmentSelection['lowerSelected']['ConsignmentNo'].trim() : 'Consignment #';
                  containerNo = this.consignmentSelection['lowerSelected']['ContainerNo'] ? this.consignmentSelection['lowerSelected']['ContainerNo'].trim() : 'Container #';

                  title += '[' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ';

                  this.$set(this.consignmentBook, 'title', title);
                  
                  //-- Set Popup data
                  this.$set(this.consignmentBook['content']['popupData'], 'jobs', [Object.assign({}, this.consignmentSelection['upperSelected'], requestExport), Object.assign({}, this.consignmentSelection['lowerSelected'], requestImport)]);
                  this.$set(this.consignmentBook['content']['popupData'], 'trailers', await this.getAvailableTrailers());

                  //-- Set Popup show
                  this.showBookingPopup = true;
                  this.$set(this.consignmentBook, 'saved', false);
                  this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
                  
                  //-- Clear Interval or Reset
                  clearInterval(this.consignmentBook['timeoutInterval']);
                  this.$set(this.consignmentBook, 'timeoutInterval', null);
                  this.$set(this.consignmentBook, 'timeoutInterval', setInterval(() => {
                    if (this.consignmentBook['content']['popupData']['timeout'] > 0) {
                      this.$set(this.consignmentBook['content']['popupData'], 'timeout', (this.consignmentBook['content']['popupData']['timeout'] - 1));
                    } else {
                      clearInterval(this.consignmentBook['timeoutInterval']);
                      this.$set(this.consignmentBook, 'timeoutInterval', null);
                    }
                  }, 1000));
                }

                break;
              case 'upper':
              case 'lower':  
                //-- Verify Data (export OR import)
                var dataToPost = {
                  'server': 'production',

                  'journeyguid': this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'].trim() : '',
                  'addjourneyguid': '',
                  'bookingtype': this.consignmentSelection['portbookType'] == 'upper' ? 'export' : 'import',
                  'action': '',
                  'terminal': '',
                  'timeslot': '',
                  'notes': ''
                }

                var request = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPost);

                //-- Check incoming data
                if (!Array.isArray(request) && (typeof request == 'object')) {
                  this.$set(this.consignmentSelection, this.consignmentSelection['portbookType'] + 'Msg', { 'status': 0, 'errMsg': 'Available for Booking' });

                  //-- Set Popup title
                  var impExp = ((this.consignmentSelection['portbookType'] == 'upper') ? 'EXP' : 'IMP');
                  var consignmentNo = this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ConsignmentNo'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ConsignmentNo'].trim() : 'Consignment #';
                  var containerNo = this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ContainerNo'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['ContainerNo'].trim() : 'Container #';

                  this.$set(this.consignmentBook, 'title', 'Port Booking - [' + impExp + '] [' + consignmentNo + '] [' + containerNo + '] ');
                  
                  //-- Set Popup data
                  this.$set(this.consignmentBook['content']['popupData'], 'jobs', [Object.assign({}, this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`], request)]);
                  this.$set(this.consignmentBook['content']['popupData'], 'trailers', await this.getAvailableTrailers());

                  //-- Set Popup show
                  this.showBookingPopup = true;
                  this.$set(this.consignmentBook, 'saved', false);  
                  this.$set(this.consignmentBook['content']['popupData'], 'timeout', 300);
                  
                  //-- Clear Interval or Reset
                  clearInterval(this.consignmentBook['timeoutInterval']);
                  this.$set(this.consignmentBook, 'timeoutInterval', null);
                  this.$set(this.consignmentBook, 'timeoutInterval', setInterval(() => {
                    if (this.consignmentBook['content']['popupData']['timeout'] > 0) {
                      this.$set(this.consignmentBook['content']['popupData'], 'timeout', (this.consignmentBook['content']['popupData']['timeout'] - 1));
                    } else {
                      clearInterval(this.consignmentBook['timeoutInterval']);
                      this.$set(this.consignmentBook, 'timeoutInterval', null);
                    }
                  }, 1000));

                } else if (Array.isArray(request)) {
                  if (request[0]['Results'] > 0) {
                    this.$set(this.consignmentSelection, this.consignmentSelection['portbookType'] + 'Msg', { 'status': 1, 'errMsg': request[0]['ErrMsg'] });
                  }
                }
                break;
            }

            //-- Set Loading
            this.$set(this.consignmentSelection, 'loading', false);
          });

          break;

        case 'Depot Booking': // if the user is performing a depot booking

          this.$set(this.consignmentSelection, 'loadingMsg', 'Verifying'); // show loader
          this.$set(this.consignmentSelection, 'loading', true);

          this.popupEntryTitle = 'Depot Booking - '; // format title
          this.depotBookingJobs = [];

          if (this.consignmentSelection['upperSelected']) { // if a dropoff trip is selected
            let depotBookingResponse = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=DepotBooking', {
              'journeyguid': this.consignmentSelection['upperSelected']['JourneyGUID'],
              'depot': this.depotDropdownSelected['name'],
              
              'action': '',
              'bookingtype': '',
              'addjourneyguid': '',
              'operator': '',
              'timeslot': '',
              'notes': ''
            });

            if (!Array.isArray(depotBookingResponse) && (typeof depotBookingResponse == 'object') && !depotBookingResponse['ErrMsg']) { // received data is not an array, is a JSON object and does not contain an 'ErrMsg' field or 'ErrMsg' field is blank
              this.$set(this.consignmentSelection, 'upperMsg', { 'status': 0, 'errMsg': 'Available for Booking' });
              this.popupEntryTitle += `[DROP][${this.consignmentSelection['upperSelected']['ConsignmentNo'].trim()}][${this.consignmentSelection['upperSelected']['ContainerNo'].trim()}] `;
              this.depotBookingJobs.push(this.consignmentSelection['upperSelected']);
              this.depotBookingDepotInput = depotBookingResponse['info']['fullname'] ? depotBookingResponse['info']['fullname'] : depotBookingResponse['info']['shortname'];
              this.depotBookingTimeslots = depotBookingResponse['slots'];
            } else if (Array.isArray(depotBookingResponse) && depotBookingResponse[0]['ErrMsg']) { // received data is an array and the 'ErrMsg' field is not blank
              this.$set(this.consignmentSelection, 'upperMsg', { 'status': 1, 'errMsg': depotBookingResponse[0]['ErrMsg'] });
            }
          }

          if (this.consignmentSelection['lowerSelected']) { // if a pickup trip is selected
            let depotBookingResponse = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=DepotBooking', {
              'journeyguid': this.consignmentSelection['lowerSelected']['JourneyGUID'],
              'depot': this.depotDropdownSelected['name'],
              
              'action': '',
              'bookingtype': '',
              'addjourneyguid': '',
              'operator': '',
              'timeslot': '',
              'notes': ''
            });

            if (!Array.isArray(depotBookingResponse) && (typeof depotBookingResponse == 'object') && !depotBookingResponse['ErrMsg']) { // received data is not an array, is a JSON object and does not contain an 'ErrMsg' field or 'ErrMsg' field is blank
              this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 0, 'errMsg': 'Available for Booking' });
              this.popupEntryTitle += `[PICK][${this.consignmentSelection['lowerSelected']['ConsignmentNo'].trim()}][${this.consignmentSelection['lowerSelected']['ContainerNo'].trim()}] `;
              this.depotBookingJobs.push(this.consignmentSelection['lowerSelected']);
              this.depotBookingDepotInput = depotBookingResponse['info']['fullname'] ? depotBookingResponse['info']['fullname'] : depotBookingResponse['info']['shortname'];
              this.depotBookingTimeslots = depotBookingResponse['slots'];
            } else if (Array.isArray(depotBookingResponse) && depotBookingResponse[0]['ErrMsg']) { // received data is an array and the 'ErrMsg' field is not blank
              this.$set(this.consignmentSelection, 'lowerMsg', { 'status': 1, 'errMsg': depotBookingResponse[0]['ErrMsg'] });
            }
          }

          this.$set(this.consignmentSelection, 'loading', false);

          if (this.consignmentSelection['upperMsg']['status'] != 0 || this.consignmentSelection['lowerMsg']['status'] != 0) // if either dropoff or pickup is invalid
            return; // exit function

          this.depotBookingSelectedTimeslot = null;
          this.depotBookingSelectedOperator = null;
          this.depotBookingTrailers = await this.getAvailableTrailers();

          if (this.depotBookingJobs[0]["TRCode"]) { // if TRCode of first job has a value
            this.depotBookingSelectedTrailer = this.depotBookingTrailers.find((trailer) => {
              return trailer["VehicleCode"] == this.depotBookingJobs[0]["TRCode"]; // attempt to find matching trailer
            });
          }
          if (
            !this.depotBookingSelectedTrailer && // if no trailer was found from TRCode in the first job
            this.depotBookingJobs[1] && // there is a b2b job
            this.depotBookingJobs[1]["TRCode"] // TRCode of the b2b job has a value
          ) {
            this.depotBookingSelectedTrailer = this.depotBookingTrailers.find((trailer) => {
              return trailer["VehicleCode"] == this.depotBookingJobs[1]["TRCode"]; // attempt to find matching trailer from TRCode in b2b job
            });
          }
          
          this.depotBookingRemarks = '';
          this.popupEntryViewMode = false;
          this.popupEntryClearMessages();


          this.depotBookingTimeoutTime = 300; // timeout after 300 seconds (5 minutes)
          this.depotBookingTimeoutInterval = setInterval(() => {
            if (--this.depotBookingTimeoutTime <= 0) { // prefix decrement, decrement value first before checking if less than or equal to 0
              clearInterval(this.depotBookingTimeoutInterval);
              this.popupEntryViewMode = true;
            }
          }, 1000);

          this.showPopupEntry = true;
          break;
      }
    },
    entryPopupSaveClicked: async function() { // save port booking (right now only Port Booking uses EntryPopup)
      this.$set(this.consignmentBook, 'successMessages', []);
      this.$set(this.consignmentBook, 'errorMessages', []);

      let error = false;

      if (this.consignmentBook['content']['popupData']['jobs'].filter((d, i) => { return d['timeslotsSel']; })['length'] == 0) {
        this.$set(this.consignmentBook, 'errorMessages', ['No timeslot was selected, please select a timeslot.']);
        error = true;
      }

      if (
        (
          !this.consignmentBook['content']['popupData']['trailersSel'] ||
          Object.keys(this.consignmentBook['content']['popupData']['trailersSel']).length == 0
        ) && // no trailer object selected AND
        (
          !this.consignmentBook['content']['popupData']['trailersSearch'] || // trailers dropdown free text is empty OR
          !this.consignmentBook['content']['popupData']['trailersSearch'].trim() // free text is just whitespace
        )
      ) {
        this.$set(this.consignmentBook, 'errorMessages', [...this.consignmentBook['errorMessages'], 'No trailer was selected, please select a trailer']);
        error = true;
      }

      if (error) { // if any of the required inputs are blank, exit function
        return;
      }

      //-- Get data of 1st item
      var jobData = this.consignmentBook['content']['popupData']['jobs'][0];

      let trailer = "";
      if (
        !this.consignmentBook['content']['popupData']['trailersSel'] || // if there's no trailer object selected OR
        !this.consignmentBook['content']['popupData']['trailersSel']['VehicleCode'] // the selected trailer object has no VehicleCode for some reason
      ) {
        trailer = this.consignmentBook['content']['popupData']['trailersSearch'].trim(); // use the free text input
      } else if (
        this.consignmentBook['content']['popupData']['trailersSel']['description'].trim() === // if description is the same as free text
        this.consignmentBook['content']['popupData']['trailersSearch'].trim()
      ) {
        trailer = (
          this.consignmentBook['content']['popupData']['trailersSel']['orivehicleno'] || // use orivehicleno if it exists
          this.consignmentBook['content']['popupData']['trailersSel']['VehicleCode'] // if not then use VehicleCode
        );
      } else { // if description is different from free text
        trailer = this.consignmentBook['content']['popupData']['trailersSearch'].trim(); // use the free text input
      }

      //-- Save Data (Final, or known as 2nd API call)
      var dataToPost = {
        'server': 'production',
        'journeyguid': (this.consignmentSelection['portbookType'] == 'upperlower') ? (this.consignmentSelection['upperSelected']['JourneyGUID'] ? this.consignmentSelection['upperSelected']['JourneyGUID'].trim() : '') : (this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'] ? this.consignmentSelection[`${this.consignmentSelection['portbookType']}Selected`]['JourneyGUID'].trim() : ''),
        'addjourneyguid': (this.consignmentSelection['portbookType'] == 'upperlower') ? (this.consignmentSelection['lowerSelected']['JourneyGUID'] ? this.consignmentSelection['lowerSelected']['JourneyGUID'].trim() : '') : '',
        'bookingtype': this.consignmentSelection['portbookType'] == 'upperlower' ? 'exportimport' : (this.consignmentSelection['portbookType'] == 'upper' ? 'export' : 'import'),
        'action': 'N',
        'terminal': (jobData ? (jobData['usecontterminal'] ? jobData['usecontterminal'].trim() : '') : ''),
        'timeslot': (jobData ? (jobData['timeslotsSel'] ? jobData['timeslotsSel']['start'].trim() : '') : ''),
        'trailer': trailer,
        'notes': (jobData ? (jobData['remarks'] ? jobData['remarks'].trim() : '') : ''),
      }

      this.$set(this.consignmentBook['content']['popupData'], 'loadText', 'Saving');

      var request = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=PortBooking', dataToPost);
      
      if (Array.isArray(request)) {
        if (request[0]['Results'] <= 0) {
          this.$set(this.consignmentBook, 'successMessages', ['Booking successful.']);
          this.$set(this.consignmentBook, 'saved', true);
        } else { 
          this.$set(this.consignmentBook, 'errorMessages', [request[0]['ErrMsg']]);
        }

      } else if (typeof request == 'object') { // sus
        this.$set(this.consignmentBook, 'successMessages', ['Booking successful.']);
        this.$set(this.consignmentBook, 'saved', true);
      } else {
        this.$set(this.consignmentBook, 'errorMessages', [request]);
      }

      this.$set(this.consignmentBook['content']['popupData'], 'loadText', '');
    },
    popupEntryClearMessages: function() { // clear all messages shown on PopupEntry
      this.popupEntryMessages = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryErrorMessages = [];
      this.popupEntryRequiredError = [];
    },
    popupEntrySaveClicked: async function() {
      switch (this.mode) {
        case 'Depot Booking': // right now, only Depot Booking uses PopupEntry, add other branches once more functionality has been added
          this.popupEntryClearMessages();

          if (!this.depotBookingSelectedTimeslot)
            this.popupEntryRequiredError.push({'Key':'timeslot', 'Value':'Please select a timeslot'});
          
          if (!this.depotBookingSelectedOperator)
            this.popupEntryRequiredError.push({'Key':'operator', 'Value':'Please select an operator'});

          if (!this.depotBookingSelectedTrailer)
            this.popupEntryRequiredError.push({'Key':'trailer', 'Value':'Please select a trailer'});
          
          if (this.popupEntryRequiredError.length > 0) // if timeslot, operator or trailer is blank
            return; // exit function

          let depotBookingRequestBody = {
            'action': 'N',
            'bookingtype': '',
            'journeyguid': '',
            'addjourneyguid': '',
            'depot': this.depotDropdownSelected['name'],
            'timeslot': this.depotBookingSelectedTimeslot['start'].trim(),
            'operator': this.depotBookingSelectedOperator['operator'].trim(),
            'trailer': this.depotBookingSelectedTrailer['orivehicleno'] || this.depotBookingSelectedTrailer['VehicleCode'],
            'notes': this.depotBookingRemarks.trim()
          };

          if (this.depotBookingJobs.length == 2) { // dropoff & pickup
            depotBookingRequestBody['bookingtype'] = 'droppickup';
            depotBookingRequestBody['journeyguid'] = this.consignmentSelection['upperSelected']['JourneyGUID'];
            depotBookingRequestBody['addjourneyguid'] = this.consignmentSelection['lowerSelected']['JourneyGUID'];
          } else if (this.consignmentSelection['upperSelected']) { // dropoff only
            depotBookingRequestBody['bookingtype'] = 'drop';
            depotBookingRequestBody['journeyguid'] = this.consignmentSelection['upperSelected']['JourneyGUID'];
          } else { // pickup only
            depotBookingRequestBody['bookingtype'] = 'pickup';
            depotBookingRequestBody['journeyguid'] = this.consignmentSelection['lowerSelected']['JourneyGUID'];
          }

          this.$fullscreenLoading("Creating Depot Booking");
          let depotBookingResponse = await this.$apiCallV2('/VehicleSchedule/PortBooking?booking=DepotBooking', depotBookingRequestBody);

          if (Array.isArray(depotBookingResponse)) { // copied from save port booking and modified accordingly
            if (depotBookingResponse[0]['Results'] == 0) {
              this.popupEntrySuccessMessages.push('Booking successful.');
              this.popupEntryViewMode = true;
            } else { 
              this.popupEntryErrorMessages.push(depotBookingResponse[0]['ErrMsg']);
            }
            // sus
          } else if (typeof request == 'object') {
            this.popupEntrySuccessMessages.push('Booking successful.');
            this.popupEntryViewMode = true;
          } else {
            this.popupEntryErrorMessages.push(depotBookingResponse[0]['ErrMsg']);
          }
          this.$fullscreenLoading();
          break;
      }
    },
    popupEntryRequiredClicked: function(event) { // called when a required message shown in PopupEntry is clicked
      switch (this.mode) {
        case 'Depot Booking': // right now, only Depot Booking uses PopupEntry, add other branches once more functionality has been added
          
          switch (event) {
            case 'timeslot':
              this.$refs['depotBookingTimeslotDropdown'].setFocus(); // expand timeslot dropdown in popupentry
              break;

            case 'operator':
              this.$refs['depotBookingOperatorDropdown'].setFocus(); // expand operator dropdown in popupentry
              break;

            case 'trailer':
              this.$refs['depotBookingTrailerDropdown'].setFocus(); // expand trailer dropdown in popupentry
          }

          break;
      }
    },
    filterPMTeam: function(selectedPMTeams){
      if (!Array.isArray(this.ganttItems)) {
        this.filteredGanttItems = [];
        return;
      }
      if (!selectedPMTeams || selectedPMTeams.Team == 'ALL') {
        this.filteredGanttItems = [...this.ganttItems];
        return;
      }

      this.filteredGanttItems = this.ganttItems.filter(item =>
        item.pcol1text === selectedPMTeams.Team || item.pcol2text === selectedPMTeams.Team
      );
    },
    formatDate: function(dateStr) {
      // Convert "2023.08.10" to "10-08-2023"
      const parts = dateStr.split('.');
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    onTripAssigned: async function() {
      this.$fullscreenLoading('Refreshing Timeline');
      await this.getGanttDetails();
      this.$fullscreenLoading();
    },
  },
  async mounted() {
    const mountedTasks = [
      () => this.getGanttDetails(),

      async () => {
        this.legendsItems = await this.$apiCallV2('/VehicleSchedule/GetLegends?viewType=TEAM_PM');
      },

      async () => {
        const result = await this.$apiCallV2('/Master/GetListMaster', {masterfile: 'Team'});
        this.PMTeamsItems = [{ '#': 5, Team: 'ALL' }, ...(result || [])];
      },

      async () => {
        const result = await this.getQuickFindField('searchby');
        this.quickFindSearchByDropdownItems = result;

        if (result && result.length > 0) {
          this.quickFindSearchByDropdownSelectedObject = result[0];
          this.quickFindSearchValueControlType = result[0]['ControlType'];
        }
      },

      async () => {
        const result = await this.getQuickFindField('criteria');
        this.quickFindSearchCriteriaDropdownItems = result;

        if (result && result.length > 0) {
          this.quickFindSearchCriteriaDropdownSelectedObject = result[0];
        }
      },

      async () => {
        const result = await this.getQuickFindField('viewoption');
        this.quickFindViewOptionDropdownItems = result;

        if (result && result.length > 0) {
          this.quickFindViewOptionDropdownSelectedObject = result[0];
        }
      },
    ];

    let completed = 0;
    const total = mountedTasks.length;
    this.quickFindMaxRowsInputValue = '100';

    const results = await Promise.allSettled(
      mountedTasks.map(async (task) => {
        try {
          await task();
        } finally {
          this.$topLoading(++completed / total);
        }
      })
    );

    results.forEach((result) => {
      if (result.status === 'rejected') {
        console.error('Vehicle Schedule initial loading failed:', result.reason);
      }
    });

    this.filterPMTeam();
    this.syncVehicleGanttViewport();
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onRefreshDropdownMouseDown, true);
    if (this.ganttViewportSyncTimer) {
      clearTimeout(this.ganttViewportSyncTimer);
      this.ganttViewportSyncTimer = 0;
    }
  },
  watch: {
    vehicleTaskRequest: function() {
      this.refreshVehicleTaskCount();
    },
    showRefreshDropdown: function(shown) {
      if (shown) {
        document.addEventListener('mousedown', this.onRefreshDropdownMouseDown, true);
      } else {
        document.removeEventListener('mousedown', this.onRefreshDropdownMouseDown, true);
      }
    },
    showQuickFindPopup: function(shown) {
      if (shown) {
        // everytime the popup is shown, don't reset the filters
        // so that users can quickly search again using their previous filters
        // just clear out the TableBox data so that the users are always forced to get the latest data
        this.quickFindFiltersExtraSpaceText = "";
        this.quickFindResultsTableBoxData = [];
        this.quickFindResultsTableBoxSelectedIndex = [];
      }
    },
    quickFindSearchByDropdownSelectedObject: {
      handler: function(newSelectedObject) {
        if (newSelectedObject && newSelectedObject["ControlType"]) {
          this.quickFindSearchValueControlType = newSelectedObject["ControlType"];
          this.quickFindSearchValueIsDisabled = false;
        } else {
          this.quickFindSearchValueIsDisabled = true;
        }

        if (newSelectedObject && newSelectedObject["Search"].toLowerCase().includes("date")) { // if selected searchBy has "date" in it
          this.quickFindSearchCriteriaDropdownSelectedObject = ( // force criteria to be "EQUALS TO"
            this.quickFindSearchCriteriaDropdownItems.find((item) => { return item["Criteria"].toLowerCase() === "equals to"; }) ||
            {}
          );
          this.quickFindSearchCriteriaDropdownIsDisabled = true; // disallow selection of other criteria
        } else {
          this.quickFindSearchCriteriaDropdownIsDisabled = false;
        }
      },
      deep: true,
    },
    rightMenuShow: function() {
      this.rightMenuSlideOpen = this.rightMenuShow;
      this.syncVehicleGanttViewport();
    },
    rightMenuWidth: function() {
      this.syncVehicleGanttViewport();
    },
    showAssignPanel: async function(shown) {
      if (
        !shown && // if AssignV3 is closed AND
        // quickFindSelectClicked will hide all other panes, no need to check
        // !this.consignmentDetails && // consignment details is not shown AND
        // this.consignmentSelection["select"] === "" && // pending trips list for port/depot booking is not shown AND
        // !this.consignmentSelection["show"] && // trips selection for port/depot booking is not shown AND
        // !this.radioCallTabShow && // HMSUpdateStatusTask component is not shown AND
        !this.showRightMenuHome // right menu home is not shown
      ) {
        this.closeRightMenu(); // close the entire right menu
        return; // basically if nothing else is using the right menu after AssignV3 is closed, close the whole right menu as well
      } 

      this.rightMenuHomeSelectedIndex = { // reset rightMenuHomeSelectedIndex to unselect consignment
        "tripType": "",
        "index": -1,
      };
      this.selectedWhiteContainer = null; // unselect consignment

      if (this.showPendingTrips) { // if the pending trips box is expanded
        this.pendingTripsIsLoading = true;
        this.pendingTrips = await this.getDriverTrips(this.selectedDriver, 0); // refresh trips instantly
        this.pendingTripsIsLoading = false;
      } else { // if the pending trips box is collapsed
        this.pendingTrips = []; // just clear the list, it will be refreshed the next time the box is expanded
      }

      if (this.showTripsHistory) { // if the trips history box is expanded
        this.tripsHistoryIsLoading = true;
        this.tripsHistory = await this.getDriverTrips(this.selectedDriver, 1); // refresh trips instantly
        this.tripsHistoryIsLoading = false;
      } else { // if the trips history box is collapsed
        this.tripsHistory = []; // just clear the list, it will be refreshed the next time the box is expanded
      }
    },
    showBookingPopup: function(val) {
      if (this.refreshInterval) {
        if (val) {
          clearInterval(this.refreshInterval);
        } else {
          this.refreshIntervalClicked(null, this.refreshTime);
        }
      }
    },
    depotBookingSelectedTimeslot: function(val) {
      this.depotBookingSelectedOperator = null;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.vehicle-schedule-main {
  width: 100%;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  padding: 10px 5px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;

  > .gantt-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    height: 100%;
    width: auto;
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    transition: none;
    position: relative;

    > .header-bar {
      margin-bottom: 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      row-gap: 5px;

      .extra-filters-bottom {
        margin-top: 5px;
        text-align: left;
      }

      .filters-extra-space {
        height: 28px;
        padding-left: 5px;
        display: flex;
        align-items: center;
      }

      > .date-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 5px;

        > * {
          margin-left: 5px;
        }

        > .date-title {
          height: 100%;
          position: relative;
          top: 3px;
        }

        > .refresh-container {
          position: relative;
          min-width: 200px;

          > button {
            width: 100%;
          }

          > .refresh-dropdown {
            position: absolute;
            top: 100%;
            background-color: white;
            width: 100%;
            z-index: 10;
            padding: 5px;
            border-width: 1px;
            border-style: solid;
            border-color: transparent black black black;

            > button {
              width: 100%;
              border-radius: 0;
              padding: 3px;
            }

            > .refresh-now {
              margin: 5px 0;
            }

            > .cancel-refresh {
              background-color: red;
              color: white;
            }
          }
        }

        > .last-refresh {
          margin: 0 5px;
        }
      }
    }

    > .gantt-with-legends {
      flex: 1 1 auto;
      min-height: 0;
      min-width: 0;
      display: flex;

      > .gantt-legends {
        min-width: 100px;
        max-width: 100px;
        height: fit-content;
        font-size: 10px;
        margin-left: 5px;

        > .gantt-legends-items {
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          > .gantt-legends-color {
            max-width: 20px;
            min-width: 20px;
            max-height: 20px;
            min-height: 20px;
            margin-right: 3px;
          }
        }
      }
    }

    > .gantt-loader {
      position: absolute;
      left: 0;
      top: 0 !important;
      height: 100% !important;
      width: 100%;
    }
  }

  > .vehicle-schedule-body {
    width: auto;
    height: 100%;
    padding: 5px;
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 5px;
    overflow-x: scroll;

    > .portBPopup {
      width: auto;
      height: auto;
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
    }
  }

  > .delete-trip-popup {

    .prompt {
      margin-bottom: 5px;
    }

    .trip-details {
      margin: 5px 44px 5px 44px;

      .detail-name {
        width: 40%;
        text-align: left;
      }

      .detail-colon {
        width: 5%;
      }

      .detail-value {
        text-align: left;
      }
    }

    .reason {
      margin: 5px 44px 5px 44px;
      width: calc(100% - 44px - 44px); // 100% minus left and right margins
    }
  }
}

.vehicle-schedule-main.right-menu-layout-open > .gantt-container {
  margin-right: var(--vehicle-right-menu-width);
}

.right-menu-content-container {
  background-color: white;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 98;

  > * {
    width: 100%;
    padding: 5px;
    display: flex;
  }

  > .header-container {
    min-height: 30px;
    max-height: 30px;
    width: 100%;
    background-color: #535cda  !important;
    // background-color: #f24a01;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-radius: 5px 5px 0 0;

    > .header-back-button {
      padding-left: 5px;
      padding-right: 10px;
      cursor: pointer;
    }

    > .header-title {
      width: calc(100% - 30px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
    }
  }

  > .body-container {
    height: 100%;
    background-color: #eaeaea;
    overflow: auto;

    > .loading-hms-trips {
      width: 100%;
      text-align: center;
    }

    > .assign-panel-container {
      height: 100%;
      width: 100%;
    }

    > .consignment-details {
      width: 100%;
      height: 100%;

      > .consignment-row {
        display: flex;
        margin-bottom: 5px;

        > .consignment-label {
          min-width: 112px;
          font-weight: bold;
        }
        > .consignment-details-left {
          min-width: 150px;
        }

        > .consignment-details-right {
          flex-grow: 1;
          text-align: left;
          white-space: normal;
          // font-weight: 900;
        }
      }
    }

    > .port-depot-trips-list-container {
      width: 100%;

      > .port-depot-trips-loading-text {
        width: 100%;
        display: flex;
        justify-content: center;
      }

      > .no-port-depot-trips {
        width: 100%;
        display: flex;
        justify-content: center;
      }

      > .port-depot-trips-list {
        display: flex;
        flex-direction: column;

        > .hms-trips-content {
          background-color: white;
          border: 1px solid black;
          width: 100%;
          padding: 5px;
          margin-bottom: 5px;
          position: relative;
          padding-right: 25px;
          height: fit-content;
          cursor: pointer;

          &:hover {
            background-color: #a6acff;
            /* box-shadow: inset 0 0 1000px white !important; */
            color: white;
          }

          > .trips-row {
            display: flex;
            align-items: flex-start;

            > .trips-left {
              width: fit-content;
              flex-grow: 1;
              font-weight: bold;
              padding-right: 5px;
            }

            > .trips-right {
              // max-width: 100px;
              width: fit-content;
              text-align: right;
              white-space: normal;
            }
          }

          > .trips-tooltip {
            position: absolute;
            right: 3px;
            bottom: 3px;
          }
        }
      }
    }

    > .port-depot-booking-home {
      width: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      > .consignment {
        width: 100%;
        display: flex;
        margin: 0 0 10px 0;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        border: solid 1px #535cda;
        border-radius: 5px;
        
        > .title {
          width: 100%;
          height: 24px;
          background-color: #535cda;
          display: flex;
          justify-content:space-between;
          /* width: 100%;
          height: 24px;
          padding: 0 5px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #535cda;
          color: #ffffff;
          border-radius: 3px 3px 0 0; */

          > .label {
            width: fit-content;
            padding: 3px;
            color: white;
          }

          > .cancel {
            width: 16px;
            height: 16px;
            margin: 3px;
            padding: 0 0 2px 0;
            font-size: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #dddddd;
            user-select: none;
            cursor: pointer;
          }

          > .cancel:hover {
            color: #ffffff;
          }
        }

        > .content {
          width: 100%;
          padding: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          > .hms-trips-content {
            background-color: white;
            border: 1px solid black;
            width: 100%;
            padding: 5px;
            position: relative;
            padding-right: 25px;

            > .trips-row {
              display: flex;
              align-items: flex-start;

              > .trips-left {
                width: fit-content;
                flex-grow: 1;
                font-weight: bold;
                padding-right: 5px;
              }

              > .trips-right {
                // max-width: 100px;
                width: fit-content;
                text-align: right;
                white-space: nowrap;
              }
            }

            > .trips-tooltip {
              position: absolute;
              right: 3px;
              bottom: 3px;
            }
          }

          > .noselect {
            width: 100%;
            height: 65px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: solid 1px #0001;
            color: gray;
            user-select: none;
            cursor: pointer;
          }

          > .noselect:hover {
            border: solid 1px #0004;
          }

          > .errMsg { 
            width: 100%;
            height: auto;
            padding: 5px;
            margin: 5px 0 0 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            background-color: #ffd9d9;
            border: solid 1px red;
          }
        }
      }
      
      > .depot {
        width: 100%;
      }

      > .functions {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        
        > button {
          margin: 0 0 0 5px;
        }
      }

      > .note {
        width: 100%;
        height: auto;
        padding: 20px 0 0 0;
        font-size: 12px;
        color: gray;
        user-select: none;
      }
    }

    > .hms-update-status-task-container {
      height: 100%;
      width: 100%;
    }

    > .right-menu-home-container {
      width: 100%;
      height: 100%;
      overflow: hidden;

      > .pending-trips-container {
        // height: 100%; moved to template for reactivity
        width: 100%;
        transition: height 0.3s;

        > .pending-trips-header {
          width: fit-content;
          font-weight: bold;
          user-select: none;
          cursor: pointer;

          > img {
            transition: 0.3s;
          }
        }

        > .pending-trips-box {
          border: 1px solid black;
          border-radius: 3px;
          overflow-y: auto;
          transition: height 0.3s;
          background-color: white;

          > .pending-trips-loading-text {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          > .no-pending-trips {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          > .pending-trips-list {
            display: flex;
            flex-direction: column;
          }
        }
      }

      > .trips-history-container {
        // height: 100%; moved to template for reactivity
        width: 100%;
        transition: height 0.3s;

        > .trips-history-header {
          width: fit-content;
          font-weight: bold;
          user-select: none;
          cursor: pointer;

          > img {
            transition: 0.3s;
          }
        }

        > .trips-history-box {
          border: 1px solid black;
          border-radius: 3px;
          overflow-y: auto;
          transition: height 0.3s;

          > .trips-history-loading-text {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          > .no-trips-history {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          > .trips-history-list {
            display: flex;
            flex-direction: column;

            > .hms-trips-content {
              background-color: white;
              border: 1px solid black;
              width: calc(100% - 10px); // 100% minus left and right margins
              padding: 5px;
              margin: 5px;
              position: relative;
              padding-right: 25px;
              height: fit-content;

              &:hover {
                background-color: #a6acff;
                /* box-shadow: inset 0 0 1000px white !important; */
                cursor: pointer;
                color: white;
              }

              > .trips-row {
                display: flex;
                align-items: flex-start;

                > .trips-left {
                  width: fit-content;
                  flex-grow: 1;
                  font-weight: bold;
                  padding-right: 5px;
                }

                > .trips-right {
                  // max-width: 100px;
                  width: fit-content;
                  text-align: right;
                  white-space: normal;
                }
              }

              > .trips-tooltip {
                position: absolute;
                right: 3px;
                bottom: 3px;
              }
            }
          }
        }
      }
    }
  }
  

  > .footer-container {
    min-height: 50px;
    max-height: 50px;
    background-color: #eaeaea;
    align-items: center;
    border-top: 1px solid rgba(64,64,64,0.5);
    width: 100%;

    > button {
      margin: 0 5px 0 0;
      padding: 5px 6px;
      flex-shrink: 0;
      white-space: nowrap;
      width: fit-content;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    > .vehicle-tasks-button {
      margin-left: auto;
      position: relative;
      flex: 0 0 32px;
      padding: 0;

      > img { width: 18px; height: 18px; }

      > .vehicle-tasks-badge {
        position: absolute;
        top: 1px;
        right: 1px;
        min-width: 14px;
        height: 14px;
        padding: 0 2px;
        border-radius: 7px;
        background: #FFA500;
        color: white;
        font-size: 10px;
        line-height: 14px;
        text-align: center;
      }
    }

    > .more-actions {
      height: 100%;
      flex: 0 0 32px;
      margin: 0 5px 0 0;
      position: relative;

      > button {
        height: 100%;
        width: 100%;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
          height: 20px;
          width: 20px;

          > img {
            height: 15px;
            width: 15px;
          }
        }
      }

      > .actions-menu {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: calc(100% + 5px);
        right: 0;
        border: 1px solid black;
        border-radius: 3px;

        > button {
          white-space: nowrap;

          &:disabled {
            opacity: 0.7
          }
        }

        :nth-last-child(1) {
          margin-top: 2px;
        }
      }
    }

    > .message-container {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      padding: 5px;
      overflow: auto;
    }
  }

  > .loader {
    width: calc(100% - 15px);
    height: calc(100% - 60px);
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 10;

    > .load-text {
      width: auto;
      height: auto;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;
      user-select: none;
    }
  }
}

.right-menu {
  z-index: 998;
  position: absolute !important;
  top: 0;
  right: 0;
  bottom: 0;
  height: auto !important;
  width: var(--vehicle-right-menu-width) !important;
  min-width: var(--vehicle-right-menu-width) !important;
  max-width: var(--vehicle-right-menu-width) !important;
  padding: 5px !important;
  padding-left: 10px !important;
  transform: translateX(var(--vehicle-right-menu-width));
  transition: transform 0.3s ease !important;

  &.right-menu-slide-open {
    transform: none;
  }
}
// PopupEntry Depot Booking styling
.portbook-main {
  width: 100%;
  height: 100%;
  // position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > .portbook-timeout {
    width: auto;
    height: 17.5px;
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: 3.5%;
    right: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  > .portbook-timeout-cover {
    width: calc(100% - 94px);
    height: calc(95% - 140px);
    position: absolute;
    // top: -5px;
    // bottom: -5px;
    // left: -5px;
    // right: -5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 10;

    > .title {
      width: auto;
      height: auto;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 0 8px #0004;
      user-select: none;
    }
  }

  > .portbook-jobs {
    width: 60%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > .job-item {
      width: 100%;
      height: 100%;
      max-width: calc(50% - 2.5px);
      padding: 5px 5px 0 5px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      background-color: #eaeaea;
      border: solid 1px #0004;
      border-radius: 5px;

      > .job-header {
        width: 100%;
        height: 24px;
        margin: 0 0 5px 0;
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border: solid 1px #0004;
        border-radius: 5px;
      }

      > .job-row {
        width: 100%;
        height: auto; 
        padding: 2px 5px;
        margin: 0 0 5px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #ffffff;
        border: solid 1px #0004;
        border-radius: 5px;

        > .title {
          width: 100%;
          height: 20px;
          margin: 0 0 2px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .title-text {
            width: auto;
            height: 100%;
            flex: 1;
            font-size: 13px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          > .title-icon {
            width: 20px;
            height: 20px;
            user-select: none;
          }
        }

        > .value {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          > .value-row {
            width: 100%;
            height: 15px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
            overflow: hidden;
            white-space: pre;
          }
        }
      }
    }
  }

  > .portbook-functions {
    width: 40%;
    height: 100%;
    padding: 0 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    > .timeslot-details {
      width: 100%;
      height: auto; 
      padding: 5px 5px 0 5px;
      margin: 0 0 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      background-color: #eaeaea;
      border: solid 1px #0004;
      border-radius: 5px;

      > .timeslot-row {
        width: calc(33% - 3.33px);
        height: auto; 
        padding: 2px 5px;
        margin: 0 0 5px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #ffffff;
        border: solid 1px #0004;
        border-radius: 5px;

        > .title {
          width: 100%;
          height: 20px;
          margin: 0 0 2px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > .title-text {
            width: auto;
            height: 100%;
            flex: 1;
            font-size: 13px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }

        > .value {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          > .value-row {
            width: 100%;
            height: 15px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
            overflow: hidden;
            white-space: pre;
          }
        }
      }
    }

    > .portbook-remarks {
      width: 100%;
      max-height: 200px;
    }
  }
}

.hms-trips-content {
  background-color: white;
  border: 1px solid black;
  width: calc(100% - 10px); // 100% minus left and right margins
  padding: 5px;
  margin: 5px;
  position: relative;
  padding-right: 25px;
  height: fit-content;
  cursor: pointer;

  &:hover {
    background-color: #a6acff;
    /* box-shadow: inset 0 0 1000px white !important; */
    color: white;
  }

  > .trips-row {
    display: flex;
    align-items: flex-start;

    > .trips-left {
      width: fit-content;
      flex-grow: 1;
      font-weight: bold;
      padding-right: 5px;
    }

    > .trips-right {
      // max-width: 100px;
      width: fit-content;
      text-align: right;
      white-space: normal;
    }
  }

  > .trips-tooltip {
    position: absolute;
    right: 3px;
    bottom: 3px;
  }
}

</style>
